<template>
  <div id="linebox">

    <el-tabs v-model="form.inquiry_pcba_type">
      <el-tab-pane label="PCBA Introduction" name="2">
        <div class="firstbox">
          <div id="pcba-instruction-main" class="pcba-contain">
            <div class="pcba-des">
              The PCBA batch manufacturing service of Well-Link Chips is mainly based on ODM/OEM orders, we focus on
              one-stop fast production from batch/multi-variety&amp;small batch PCBA to finished product assembly, with
              speed、quality、technology and service as the core business philosophy, we also independently develop MES
              +ERP+IOT management system to achieve industrial intelligent factory, provides PCBA one-stop service in
              industrial control, smart home, instrumentation, vehicle IoT, communication power supply, medical
              equipment, automotive electronics, and other fields; with ISO9001、ISO13485、ISO14000 and IATF16949 quality
              system as the standard management, to be the leader of domestic SMT focusing on small and medium-sized
              batches of high-end PCBA production.
            </div>

            <div class="pcba-service">
              <div class="service-title">
                Service Instruction
              </div>

              <div class="service-item">
                <div class="service-item-title"> One-stop PCBA Procurement Service </div>
                <div class="service-item-list">
                  <div class="item1">
                    <div class="item1-title">PCBA fast manufacturing</div>
                    <div class="item1-content">
                      <p>
                        1. Support panelized/single PCB, SMD/THT, 1-20 layers PCBA,
                        multi-variety design, small-batch manufacturing
                      </p>
                      <p>
                        2. Follow the ISO9001 quality management system, standard
                        operating procedures, and high-quality assurance
                      </p>
                    </div>
                  </div>

                  <div class="item1">
                    <div class="item1-title">PCB procurement</div>
                    <div class="item1-content">
                      <p>Kingboard A-grade FR-4 material, supports
                        1-20 layers of PCB, the minimum via diameter is 0.15mm,
                        and the minimum PCB thickness is 0.6mm
                      </p>
                    </div>
                  </div>

                  <div class="item1">
                    <div class="item1-title">IC procurement</div>
                    <div class="item1-content">
                      <p>
                        In-stock goods value is over 80 million RMB, authorized by
                        IC manufacturers over 50+, a global procurement team with rich
                        experience, and 3000+ high-quality suppliers worldwide
                      </p>
                    </div>
                  </div>

                  <div class="clear"></div>
                </div>
              </div>
            </div>


            <div class="pcba-service">
              <div class="service-title">
                Equipments
              </div>
              <div class="equipments">
                <ul>
                  <li>
                    <label>SMT workshop</label>
                    <img src="../src/assets/images/01.jpg">
                  </li>
                  <li>
                    <label>Solder Paste Inspection System</label>
                    <img src="../src/assets/images/02.jpg">
                  </li>
                  <li>
                    <label>SMT First Article Inspection</label>
                    <img src="../src/assets/images/03.jpg">
                  </li>
                  <li class="eq-end">
                    <label>Wave-slodering machine </label>
                    <img src="../src/assets/images/04.jpg">
                  </li>
                  <div class="clear"></div>
                </ul>

                <ul>
                  <li>
                    <label>AOI optical inspection equipment</label>
                    <img src="../src/assets/images/05.jpg">
                  </li>
                  <li>
                    <label>SMT machine</label>
                    <img src="../src/assets/images/06.jpg">
                  </li>
                  <li>
                    <label>SMT machine</label>
                    <img src="../src/assets/images/07.jpg">
                  </li>
                  <li class="eq-end">
                    <label>Double In-line Package</label>
                    <img src="../src/assets/images/08.jpg">
                  </li>
                  <div class="clear"></div>
                </ul>

                <ul>
                  <li>
                    <label>Automatic solder paste machine</label>
                    <img src="../src/assets/images/09.jpg">
                  </li>
                  <li>
                    <label>Automatic separating machine</label>
                    <img src="../src/assets/images/10.jpg">
                  </li>
                  <li>
                    <label>X-RAY component counter</label>
                    <img src="../src/assets/images/11.jpg">
                  </li>
                  <li class="eq-end">
                    <label>Reflow soldering machine</label>
                    <img src="../src/assets/images/12.jpg">
                  </li>
                  <div class="clear"></div>
                </ul>

              </div>
            </div>


            <div class="pcba-service">
              <div class="service-title">
                Cases of cooperation
              </div>

              <div class="cases">
                <ul>
                  <li>
                    <img src="../src/assets/images/13.jpg">
                  </li>
                  <li>
                    <img src="../src/assets/images/14.jpg">
                  </li>
                  <li>
                    <img src="../src/assets/images/15.jpg">
                  </li>
                  <li>
                    <img src="../src/assets/images/16.jpg">
                  </li>
                  <li>
                    <img src="../src/assets/images/17.jpg">
                  </li>
                  <li>
                    <img src="../src/assets/images/18.jpg">
                  </li>
                  <li>
                    <img src="../src/assets/images/19.jpg">
                  </li>
                  <li>
                    <img src="../src/assets/images/20.jpg">
                  </li>
                </ul>
                <div class="clear"></div>
                <div class="cases-txt">Industrial control, instrumentation, new energy, medical equipment, automotive
                  electronics</div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="PCB" name="1">
        <div class="pcba-contain">

          <div class="refreshsty">
            <a @click="refreshFun1">
              Reset
            </a>
          </div>
          <div>
            <div class="cerber">
              <el-upload class="custom-upload" action="" :limit="1" :file-list="fileListGerber" :show-file-list="false"
                :before-upload="beforeUploadGerber" :disabled="isUploadDisabledGerber"
                :http-request="httpRequestGerber">
                <div :class="!isUploadDisabledGerber ? 'upload-btn' : 'disabled-btn'">
                  <span class="uploadtext">Gerber File</span>
                </div>
                <div class="tip red" v-if="uploadProgressGerber != 100">
                  For special requirements not available on this page, please send your requirements and Gerber files to
                  us (<a href="#">sales@welllinkchips.com</a>) and we will come back to you with a price in 2 working
                  days.
                </div>
                <div class="jindutiao">
                  <el-progress :percentage="uploadProgressGerber"></el-progress>
                </div>

              </el-upload>

              <div class="tip" v-if="uploadProgressGerber == 100">Only ZIP or RAR files, Up to 50MB</div>

              <div class="filelist" v-if="uploadProgressGerber == 100">
                <img height="15" src="./assets/images/file.png">
                <div>{{ fileNameGerber }}</div>
                <span class="closebtn" @click="onRemoveGerber"><i class="el-icon-close"></i></span>
              </div>

              <div class="tip red" v-if="uploadProgressGerber == 100">Please select the
                specifications
                below to place an order.</div>
            </div>

            <el-form ref="form" :model="form" :rules="rules" label-position="left" class="formbox">
              <!-- Material Type -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Material Type
                    </span>
                    <el-popover width="200" trigger="hover" class="item" content="Non-conductive base matenal"
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.material_type" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.material_type_list" :key="item.key">
                    <el-radio :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.material_type === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>


              <!-- Layer Count -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Layer Count
                    </span>
                    <el-popover width="200" trigger="hover" class="item" content="Number of copper layers."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group @change="changeLayerCount" v-model="form.layer_count" class="custom-radio-group">
                  <div class="radio-wrap" v-for="(item, index) in dataMap.layerCountList" :key="'layer_count' + index">
                    <el-radio :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.layer_count === item.value" src="./assets/gou.png">
                  </div>
                  <!-- <div class="radio-wrap" >

                  <el-radio label="22-32">
                    22-32
                  <el-popover width="200" trigger="hover" class="item"  content="Non-conductive base material" placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                  </el-radio>
                  
                </div> -->
                </el-radio-group>
              </el-form-item>

              <!-- TG -->
              <el-form-item class="form-item" v-if="showTG">
                <template name="label">
                  <div class="label-text">
                    <span>
                      TG
                    </span>
                    <el-popover width="200" trigger="hover" class="item" content="Non-conductive base material"
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.tg" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.TGList" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.key">{{ item.key }}</el-radio>
                    <img class="active-img" v-show="form.tg === item.key" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Board Type -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Board Type
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="The finihed PCB are by single or by panel." placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.board_type" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.board_type_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.label }}</el-radio>
                    <img class="active-img" v-show="form.board_type === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- <div class="line" style="margin-top:10px" v-if="form.board_type == 'Single piece'">
              </div> -->
              <div class="line" style="margin-top:10px" v-if="form.board_type == 'Panel by Customer'">
                We panelize the board according to your PCB file
              </div>
              <div class="line" style="margin-top:10px" v-if="form.board_type == 'Panel by welllink'">
                welllink will panelize the board for you
              </div>
              <!-- Size (single) -->
              <el-form-item class="form-item" style="margin-top:10px">

                <template name="label">
                  <div class="label-text">

                    <label class="red">*</label>
                    <span>
                      Size (single)
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="The maximum length and width of the PCB" placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <div class="numgroup">
                  <div id="select-item-id5" class="select-item-right">
                    <span class="span"><input placeholder="Length" v-model="form.size_one" type="text" @input="size_one_Change"/></span>
                    <span class="span spanx">X</span>
                    <span class="span"><input placeholder="Width" v-model="form.size_two" type="text"  @input="size_two_Change"/></span><span
                      class="mm">mm</span>
                    <div class="clear"></div>
                  </div>
                </div>
              </el-form-item>

              <!-- <div class="line" style="margin-top:10px">
                OSP is not available for boards less than 80 x 50 mm in size
              </div> -->

              <!-- Qty(single) -->
              <el-form-item class="form-item qtyid" prop="qty">
                <template name="label">
                  <div class="label-text">

                    <label class="red">*</label>
                    <span>
                      Qty(single)
                    </span>
                    <el-popover width="200" trigger="hover" placement="right">
                      <div v-html="`Quantity of single or panelized boards needed for the order.`"></div>
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>

                  </div>
                </template>
                <div class="numgroup">
                  <el-popover ref="popover" placement="right" width="300" trigger="click">
                    <div class="numberboxsty">
                      <ul class="clearfix">
                        <li class="trans-animate" v-for="(item, index) in dataMap.qty_list" :key="item.key"
                          :class="{ active: activeTag === index }" @click="numberChange(item.value, index)">{{
                            item.value
                          }}
                        </li>
                      </ul>
                    <div class="clear"></div>
                      <p class="linetextsty">Select multiples of 5 in the blank of "Quantity: (pcs)" when your Single
                        layer/Double layer
                        PCB is larger than 10㎡. </p>
                      <ul class="submitsty">
                        <li>Other:</li>
                        <li><el-input v-model="form.qty" style="width:76px"></el-input></li>
                        <li><el-button type="small" class="redcolor" @click="closePopover(1)">Submit</el-button></li>
                        <li><el-button type="small" @click="closePopover(1)">Cancel</el-button></li>
                      </ul>
                    </div>
                    <div class="select-item-right" slot="reference">
                      <span class="span"><input placeholder="" v-model="form.qty" type="text" readonly></span>
                      <span class="mm">pcs</span>
                    </div>
                  </el-popover>

                </div>
              </el-form-item>

      

          
              <!-- Break-away Rail -->
              <el-form-item class="form-item qtyid">
                <template name="label">
                  <div class="label-text">
                    <label class="red">*</label>
                    <span>
                      Break-away Rail
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="Rail at the edge of panel boards for fixing the panel boards on assembly machine more easily"
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>

                <div class="numgroup">
                  <div class="input-wrap">
                    <el-select v-model="form.break_away_rail" placeholder="please input" style="width:145px">
                      <el-option v-for="item in dataMap.break_away_rail_list" :key="item.key" :label="item.value"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="input-wrap" v-if="form.break_away_rail != 'N/A'">
                    <div class="select-item-right">
                      <span class="span"><input placeholder="" v-model="form.break_away_rail_num" type="text" @input="break_away_rail_num_Change"></span>
                      <span class="mm">mm</span>
                    </div>
                  </div>

                </div>


              </el-form-item>
              <div class="line" style="margin-top:10px" v-if="form.break_away_rail != 'N/A'">
                The minimum size is 3mm
              </div>
              <!-- PCB Thickness -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      PCB Thickness
                    </span>
                    <el-popover width="200" trigger="hover" class="item" content="The thickness of finished board."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.pcb_thickness" class="custom-radio-group">
                  <div class="radio-wrap" v-for="(pcbItem, index) in pcbList" :key="'pcb_thickness' + index">
                    <el-radio :disabled="pcbItem.disabled" :label="pcbItem.value">{{ pcbItem.value }}</el-radio>
                    <img class="active-img" v-show="form.pcb_thickness === pcbItem.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- PCB Solder Mask Color -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      PCB Solder Mask Color
                    </span>
                    <el-popover width="200" trigger="hover" class="item" content="Color of the solder mask."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>

                <div class="numgroup">
                  <el-radio-group v-model="form.pcb_solder_mask_color" class="custom-radio-to-checkbox-group"
                    @change="changePcbSoldermaskColor">
                    <div class="radio-wrap" v-for="item in dataMap.pcb_solder_mask_color_list" :key="item.key">

                      <!-- :style="{'background-color':item.value}" -->
                      <el-radio :disabled="item.disabled" :label="item.value" border
                        :class="'borderColor-' + item.key">{{
                          item.value
                        }}</el-radio>
                      <img class="active-img" v-show="form.pcb_solder_mask_color === item.value"
                        src="./assets/gou.png" />
                    </div>
                  </el-radio-group>
                </div>
              </el-form-item>
              <!-- Silkscreen -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Silkscreen
                    </span>
                    <el-popover width="200" trigger="hover" class="item" content="Color of the Silkscreen"
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <div class="numgroup">
                  <el-radio-group v-model="form.silkscreen" class="custom-radio-to-checkbox-group ">
                    <div class="radio-wrap" v-for="item in dataMap.silkscreen_list" :key="item.key">
                      <el-radio :disabled="item.disabled" :label="item.value" border
                        :class="'borderColor-' + item.key">{{
                          item.value
                        }}</el-radio>
                      <img class="active-img" v-show="form.silkscreen === item.value" src="./assets/gou.png" />
                    </div>
                  </el-radio-group>
                </div>
              </el-form-item>

              <!-- Electrical Test -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Electrical Test
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="We will do 100% electrical testing by flying probe and E-test machine."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.electrical_test" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.electrical_test_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.electrical_test === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Finished Copper Weight -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Finished Copper Weight
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="Copper weight on the outer layers(top and bottom)." placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.finished_copper_weight" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.finished_copper_weight_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.finished_copper_weight === item.value"
                      src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>

              <div class="line" style="margin-top:10px" v-if="form.finished_copper_weight == '2oz'">
                Impedance unavailable for Finished Copper thickness>=2 oz
              </div>
              <!-- PCB Inner Copper Weight -->
              <el-form-item class="form-item" v-if="pcb_inner_copper_weigh_show">
                <template name="label">
                  <div class="label-text">
                    <span>
                      PCB Inner Copper Weight
                    </span>
                    <el-popover width="200" trigger="hover" class="item" content="" placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.pcb_inner_copper_weigh" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.pcb_inner_copper_weigh_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.pcb_inner_copper_weigh === item.value"
                      src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Min. Trace / Space Outer -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Min. Trace / Space Outer
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="The narrowest width of copper in the design for all external layers."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.min_trace_space_outer" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.min_trace_space_outer_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.min_trace_space_outer === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>
              <!-- Min. Drilled Hole -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Min. Drilled Hole
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="The smallest drill size needed in the design" placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.mdh" class="custom-radio-group">
                  <div class="radio-wrap" v-for="(mdhItem, index) in mdhList" :key="'mdh' + index">
                    <el-radio :disabled="mdhItem.disabled" :label="mdhItem.value">{{ mdhItem.value }}</el-radio>
                    <img class="active-img" v-show="form.mdh === mdhItem.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Via Process -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Via Process
                    </span>
                    <el-popover width="200" trigger="hover" placement="right">
                      <div v-html="`1. Tented vias (l-A/B): Vias are covered with solder mask oil. The level of solder mask oil
                        coverage depends on the diameter and depth of the hole. Holes larger than 0,45mm in diameter
                        cannot be fully covered.<br />
                        2,Opened vias: No via covering. Openings in the solder mask layer are added so the vias are
                        exposed and are treated with surface finish.For tented/opened vias, due to the difficulty in
                        differentiating vias and plated through-holes, if Gerber files are uploaded, the engineers will
                        follow the via design in the Gerber files directly, regardless of whether tented or open vias
                        were selected.<br />
                        3. Solder Mask Plug (lV-B): Vias plugged with solder mask, The vias are first filled with solder
                        mask and then covered with solder mask oil as with tented vias, This ensures all the vias are
                        plugged with solder mask oil but may still suffer from partial filling.<br />
                        4. Non-Conductive Fill & Cap (Vll): Vias are filled with non-conductive epoxy resin then
                        'capped' with copper pads, Suitable for via-in-pad deslgns.`"></div>
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>

                  </div>
                </template>
                <el-radio-group v-model="form.via_process" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.via_process_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}
                      <el-popover width="200" trigger="hover" placement="right" v-if="item.tips">
                        <div v-html="item.tips"></div>
                        <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                      </el-popover>
                    </el-radio>
                    <img class="active-img" v-show="form.via_process === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Surface Finish -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Surface Finish
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="The applied surface finish covering the exposed copper surface (solderable surfaces) of your PCB."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.surface_finish" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.surface_finish_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}
                      <!-- <el-popover width="200" trigger="hover" class="item" :content="item.tips" placement="top-start">
                        <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                      </el-popover> -->
                    </el-radio>
                    <img class="active-img" v-show="form.surface_finish === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>
              <!-- Thickness of Immersion Gold -->

              <el-form-item class="form-item" v-if="form.surface_finish == 'ENIG'">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Thickness of Immersion Gold
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="The applied surface finish covering the exposed copper surface (solderable surfaces) of your PCB."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.thickness_of_immersion_gold" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.thickness_of_immersion_gold_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.thickness_of_immersion_gold === item.value"
                      src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>
              <!-- Special Process -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Special Process
                    </span>
                  </div>
                </template>
                <div class="numgroup">
                  <el-checkbox-group v-model="form.special_process" class="custom-checkbox-group"
                    @change="checkboxchange">

                    <div class="checkbox-wrap" v-for="(item) in dataMap.special_process_list" :key="item.key">

                      <el-checkbox :disabled="item.disabled" :label="item.label" :key="item.key" border>{{ item.value }}
                        <el-popover width="200" trigger="hover" placement="right" v-if="item.tips">
                          <div v-html="item.tips"></div>
                          <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                        </el-popover>
                      </el-checkbox>

                      <img class="active-img" v-show="form.special_process.includes(item.value)"
                        src="./assets/gou.png" />
                    </div>
                  </el-checkbox-group>
                </div>
              </el-form-item>

              <div class="line" style="margin-top:10px" v-if="form.special_process.includes('Impedance')">
                No impedance control in default, if you choose impedance control, the lead time and price will be
                different.
              </div>
              <!-- HDI Structure -->
              <el-form-item class="form-item" v-if="form.special_process.includes('HDI(Buried/blind vias)')">
                <template name="label">
                  <div class="label-text">
                    <span>
                      HDI Structure
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content='lf your PCB board needs blind buried hole process, please choose the order according to your needs'
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.hdi_structure" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.hdi_structure_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.hdi_structure === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>
              <!-- Stack up -->

              <el-form-item class="form-item" v-if="Number(this.form.layer_count) >= 4">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Stack up
                    </span>
                    <el-popover width="200" trigger="hover" placement="right">
                      <div v-html='`1. Select "No Requirement" when there is no impedance control;<br/>
2,Select "Customer Specified Stack up", additional fees will be charged;`'></div>
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.stack_up" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.stack_up_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.stack_up === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>
              <!-- X-out -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      X-out
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="Crossed boards mean that there are 1PCS or more PCS scrapped boards in a set. Although the proportion is very low, there will inevitably be crossed boards. lf the crossed board is not accepted, the entire set of boards (Set) where it is located will need to be scrapped, which will increase the cost."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form.x_out" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.x_out_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.x_out === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Personalized Service -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Personalized Service
                    </span>
                  </div>
                </template>
                <div class="numgroup">
                  <el-checkbox-group v-model="form.personalized_service" class="custom-checkbox-group">

                    <div class="checkbox-wrap" v-for="(item, index) in dataMap.personalized_service_list"
                      :key="item.key">
                      <el-checkbox :disabled="item.disabled" :label="item.label" :key="'personalized_service' + index"
                        @change="(e) => personalizedServiceChange(e, item.value)" border>{{ item.value }}
                        <el-popover width="200" trigger="hover" placement="right" v-if="item.tips">
                          {{ item.tips }}
                          <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                        </el-popover></el-checkbox>
                      <img class="active-img" v-show="form.personalized_service.includes(item.value)"
                        src="./assets/gou.png" />
                    </div>
                  </el-checkbox-group>
                </div>
              </el-form-item>
              <div class="line" style="margin-top:10px"
                v-if="form.personalized_service.includes('Delivery Report') || form.personalized_service.includes('Microsection Analysis Report')">
                If you do not need a product report, you can remove the option
              </div>
              <!-- Report Format -->
              <el-form-item class="form-item"
                v-if="form.personalized_service.includes('Delivery Report') || form.personalized_service.includes('Microsection Analysis Report')">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Report Format
                    </span>
                  </div>
                </template>
                <el-radio-group v-model="form.report_format" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.report_format_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.report_format === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- UL Mark -->
              <el-form-item class="form-item" v-if="form.personalized_service.includes('UL Mark')">
                <template name="label">
                  <div class="label-text">
                    <span>
                      UL Mark
                    </span>
                  </div>
                </template>
                <el-radio-group v-model="form.ul_mark" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.ul_mark_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form.ul_mark === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Add PO No. -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Add PO No.
                    </span>
                  </div>
                </template>
                <div class="numgroup" >
                  <el-input v-model="form.add_po_no" style="width:230px"></el-input>
                </div>
              </el-form-item>
              <!-- Special Requests -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Special Requests
                    </span>
                  </div>
                </template>
                <div class="numgroup" style="width:772px;height:217px;">
                  <div class="inputsty">
                    <el-input type="textarea"
                      placeholder="Please fill in your special requirements for the PCB orde (within 500 characters)."
                      v-model="form.special_requests" style="width:772px;height:217px;" maxlength="500" rows="5"></el-input>
                  </div>
                </div>
              </el-form-item>
              <div class="checkAddPCBsty">
                <el-checkbox v-model="form.checkAddPCB">Add PCB Assembly Free assembly for 5 pieces promo</el-checkbox>

                <div v-if="form.checkAddPCB">
                  <div class="mt20">
                    <!-- <div class="boxboder">
                      <el-upload class="custom-upload" action="" :limit="1" :file-list="fileListCoordinate"
                        :before-upload="beforeUploadGerber" :disabled="isUploadDisabledCoordinate"
                        :http-request="httpRequestCoordinate" :show-file-list="false">
                        <div :class="!isUploadDisabledCoordinate ? 'upload-btn' : 'disabled-btn'">
                          <img src="./assets/images/btn_02.png"><span class="uploadtext">Centroid File</span>
                        </div>
                        <div slot="tip" class="el-upload__tip">Only ZIP or RAR files, Up to 50MB</div>
                        <div class="jindutiao">
                          <el-progress :percentage="uploadProgressCoordinate"></el-progress>
                        </div>


                      </el-upload>

                      <div class="filelist" v-if="uploadProgressCoordinate == 100">
                        <img height="15" src="./assets/images/file.png">
                        <div>{{ fileNameCoordinate }}</div>
                        <span class="closebtn" @click="onRemoveCoordinate"><i class="el-icon-close"></i></span>
                      </div>
                    </div> -->
                    <div class="cerber">
                      <el-upload class="custom-upload" action="" :limit="1" :file-list="fileListCoordinate"
                        :before-upload="beforeUploadGerber" :disabled="isUploadDisabledCoordinate"
                        :http-request="httpRequestCoordinate" :show-file-list="false">
                        <div :class="!isUploadDisabledCoordinate ? 'upload-btn' : 'disabled-btn'">
                          <span class="uploadtext">Centroid File</span>
                        </div>
                        <div class="jindutiao">
                          <el-progress :percentage="uploadProgressCoordinate"></el-progress>
                        </div>

                      </el-upload>

                      <div class="tip">Only ZIP or RAR files, Up to 50MB</div>

                      <div class="filelist" v-if="uploadProgressCoordinate == 100">
                        <img height="15" src="./assets/images/file.png">
                        <div>{{ fileNameCoordinate }}</div>
                        <span class="closebtn" @click="onRemoveCoordinate"><i class="el-icon-close"></i></span>
                      </div>
                      <!-- 
                      <div class="tip red" v-if="uploadProgressCoordinate == 100">Please select the
                        specifications
                        below to place an order.</div> -->
                    </div>
                  </div>
                  <div class="minbox">

                    <el-form-item class="form-item">
                      <template name="label">
                        <div class="label-text">
                          <span>
                            <span class="red">*</span>PCBA Qty
                          </span>
                        </div>
                      </template>
                      <el-input v-model="form.pcba_qty" style="width:230px"></el-input>
                    </el-form-item>
                  </div>
                  <div class="mt20">
                    <!-- <div class="uploadbox">
                      <el-upload class="custom-upload" action="" :show-file-list="false" :limit="1"
                        :file-list="fileListBom" :before-upload="beforeUploadBOM" :disabled="isUploadDisabledBOM"
                        :http-request="httpRequestBom">
                        <div :class="!isUploadDisabledBOM ? 'upload-btn' : 'disabled-btn'">
                          <img src="./assets/images/btn_02.png"><span class="uploadtext">BOM File</span>
                        </div>
                        <div slot="tip" class="el-upload__tip">Only XLS / XLSX or CSV files, Up to 5MB</div>
                        <div class="jindutiao">
                          <el-progress :percentage="uploadProgressBom"></el-progress>
                        </div>
                      </el-upload>

                      <div class="filelist" v-if="uploadProgressBom == 100">
                        <img height="15" src="./assets/images/file.png">
                        <div>{{ fileNameBom }}</div>
                        <span class="closebtn" @click="onRemoveBom"><i class="el-icon-close"></i></span>
                      </div>
                    </div> -->

                    <div class="cerber">
                      <el-upload class="custom-upload" action="" :show-file-list="false" :limit="1"
                        :file-list="fileListBom" :before-upload="beforeUploadBOM" :disabled="isUploadDisabledBOM"
                        :http-request="httpRequestBom">
                        <div :class="!isUploadDisabledBOM ? 'upload-btn' : 'disabled-btn'">
                          <span class="uploadtext">BOM File</span>
                        </div>
                        <!-- <div class="tip red" v-if="uploadProgressBom != 100">
                          For special requirements not available on this page, please send your requirements and Gerber
                          files to us
                          (<a href="#">sales@welllinkchips.com</a>) and we will come back to you with a price in 2
                          working days.
                        </div> -->
                        <div class="jindutiao">
                          <el-progress :percentage="uploadProgressBom"></el-progress>
                        </div>

                      </el-upload>

                      <div class="tip">Only ZIP or RAR files, Up to 50MB</div>

                      <div class="filelist" v-if="uploadProgressBom == 100">
                        <img height="15" src="./assets/images/file.png">
                        <div>{{ fileNameBom }}</div>
                        <span class="closebtn" @click="onRemoveBom"><i class="el-icon-close"></i></span>
                      </div>

                      <!-- <div class="tip red" v-if="uploadProgressBom == 100">Please select the
                        specifications
                        below to place an order.</div> -->
                    </div>
                  </div>

                  <div class="bottom_table">
                    <p>Please make a BOM file which follows this template :</p>
                    <el-table :data="tableData" border :header-cell-style="{ background: '#f9f9f9' }"
                      :row-style="{ height: '30px' }" style="width: 100%" class="mt10 mb20">
                      <el-table-column prop="id" width="180" align="center" min-width="30px">
                      </el-table-column>
                      <el-table-column prop="designator" label="Designator *" width="180" align="center">
                      </el-table-column>
                      <el-table-column prop="qty" label="Qty *" align="center">
                      </el-table-column>
                      <el-table-column prop="manufacturerPartNumber" label="Manufacturer Part Number *" align="center">
                      </el-table-column>
                      <el-table-column prop="customerSupply" label="Customer Supply" align="center">
                      </el-table-column>
                      <el-table-column prop="customerRemark" label="Customer Remark" align="center">
                      </el-table-column>
                    </el-table>
                    <div class="mt10">
                      <p class="fc-dis quote-smt-tips">MPN is the Manufacturer Part Number, NOT Digikey or Mouser Part
                        Number.</p>
                      <p class="fc-dis quote-smt-tips">The location please use commas to distinguish.</p>
                      <p class="fc-dis quote-smt-tips">If provided by the customer, please indicate Y in the customer
                        supply column.
                      </p>
                      <p class="fc-dis quote-smt-tips">If left blank, please indicate DNP (Do Not Populate abbreviation)
                        in the
                        customer supply column</p>
                    </div>
                  </div>
                </div>

              </div>


              <div class="access-div">
                <div class="submit-items">
                  <h2 class="h2"><span class="red">*</span>Company</h2>
                  <div class="mt10">
                    <input placeholder="Company" v-model="form.company" class="submit-input" type="text" name=""
                      value="">
                  </div>
                </div>

                <div class="submit-items">
                  <h2 class="h2"><span class="red">*</span>Name</h2>
                  <div class="mt10">
                    <input placeholder="Name" v-model="form.name" class="submit-input" type="text" name="" value="">
                  </div>
                </div>

                <div class="submit-items">
                  <h2 class="h2"><span class="red">*</span>E-mail</h2>
                  <div class="mt10">
                    <input placeholder="E-mail" v-model="form.email" class="submit-input" type="text" name="" value="">
                  </div>
                </div>

                <div class="clear"></div>

                <a href="javascript:;" class="submit-form-btn" @click="onSubmit">SUBMIT</a>
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="PCB + Stencil" name="3">
        <div class="pcba-contain">
          <div class="refreshsty">
            <a @click="refreshFun2">
              Reset
            </a>
          </div>
          <div class="cerber">
            <el-upload class="custom-upload" action="" :limit="1" :show-file-list="false" :file-list="fileListGerber2"
              :before-upload="beforeUploadGerber" :disabled="isUploadDisabledGerber2"
              :http-request="httpRequestGerber2">
              <div :class="!isUploadDisabledGerber2 ? 'upload-btn' : 'disabled-btn'">
                <span class="uploadtext">Gerber File</span>
              </div>
              <div class="tip red" v-if="uploadProgressGerber2 != 100">
                For special requirements not available on this page, please send your requirements and Gerber files to
                us
                (<a href="#">sales@welllinkchips.com</a>) and we will come back to you with a price in 2 working days.
              </div>
              <div class="jindutiao">
                <el-progress :percentage="uploadProgressGerber2"></el-progress>
              </div>

            </el-upload>

            <div class="tip" v-if="uploadProgressGerber2 == 100">Only ZIP or RAR files, Up to 50MB</div>

            <div class="filelist" v-if="uploadProgressGerber2 == 100">
              <img height="15" src="./assets/images/file.png">
              <div>{{ fileNameGerber2 }}</div>
              <span class="closebtn" @click="onRemoveGerber2"><i class="el-icon-close"></i></span>
            </div>

            <div class="tip red" v-if="uploadProgressGerber2 == 100">Please select the
              specifications
              below to place an order.</div>
          </div>
          <el-form ref="form2" :model="form2" :rules="rules2" label-position="left" 
            class="formbox">
            <!-- Material Type -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Material Type
                  </span>
                  <el-popover width="200" trigger="hover" class="item" content="Non-conductive base matenal"
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.material_type" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.material_type_list" :key="item.key">
                  <el-radio :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.material_type === item.value" src="./assets/gou.png">
                </div>
              </el-radio-group>
            </el-form-item>


            <!-- Layer Count -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Layer Count
                  </span>
                  <el-popover width="200" trigger="hover" class="item" content="Number of copper layers."
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group @change="changeLayerCount2" v-model="form2.layer_count" class="custom-radio-group">
                <div class="radio-wrap" v-for="(item, index) in dataMap.layerCountList" :key="'layer_count' + index">
                  <el-radio :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.layer_count === item.value" src="./assets/gou.png">
                </div>
                <!-- <div class="radio-wrap">
                <el-radio label="22-32">
                  22-32
                  <el-popover width="200" trigger="hover" class="item"  content="Non-conductive base material" placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </el-radio>

              </div> -->
              </el-radio-group>
            </el-form-item>

            <!-- TG -->
            <el-form-item class="form-item" v-if="showTG2">
              <template name="label">
                <div class="label-text">
                  <span>
                    TG
                  </span>
                  <el-popover width="200" trigger="hover" class="item" content="Non-conductive base material"
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.tg" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.TGList" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.key">{{ item.key }}</el-radio>
                  <img class="active-img" v-show="form2.tg === item.key" src="./assets/gou.png">
                </div>
              </el-radio-group>
            </el-form-item>

            <!-- Board Type -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Board Type
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="The finihed PCB are by single or by panel." placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.board_type" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.board_type_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.label }}</el-radio>
                  <img class="active-img" v-show="form2.board_type === item.value" src="./assets/gou.png">
                </div>
              </el-radio-group>

            </el-form-item>
<!-- 
            <div class="line" style="margin-top:10px" v-if="form2.board_type == 'Single piece'">
            </div> -->
            <div class="line" style="margin-top:10px" v-if="form2.board_type == 'Panel by Customer'">
              We panelize the board according to your PCB file
            </div>
            <div class="line" style="margin-top:10px" v-if="form2.board_type == 'Panel by welllink'">
              welllink will panelize the board for you
            </div>

            <!-- Size (single) -->
            <el-form-item class="form-item" style="margin-top:10px">

              <template name="label">
                <div class="label-text">

                  <label class="red">*</label>
                  <span>
                    Size (single)
                  </span>
                  <el-popover width="200" trigger="hover" class="item" content="The maximum length and width of the PCB"
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <div class="numgroup">
                <div id="select-item-id5" class="select-item-right">
                  <span class="span"><input placeholder="Length" v-model="form2.size_one" type="text"  @input="size_one_Change2"/></span>
                  <span class="span spanx">X</span>
                  <span class="span"><input placeholder="Width" v-model="form2.size_two" type="text"  @input="size_two_Change2"/></span><span
                    class="mm">mm</span>
                </div>
                <!-- <div class="middlebox">
                <el-button>inch` <i class="el-icon-right"></i> mm</el-button>
                <el-popover width="200" trigger="hover" placement="right" width="190" trigger="hover">
                  <img class="imgsty" src="./assets/quote-case1_20220531.png" />
                  <el-link slot="reference" type="primary" style="margin-left:10px">Case Display</el-link>
                </el-popover>
              </div> -->
              </div>
            </el-form-item>

            <!-- <div class="line" style="margin-top:10px">
              OSP is not available for boards less than 80 x 50 mm in size
            </div> -->

            <!-- Qty(single) -->
            <el-form-item class="form-item qtyid" prop="qty">
              <template name="label">
                <div class="label-text">

                  <label class="red">*</label>
                  <span>
                    Qty(single)
                  </span>
                  <el-popover width="200" trigger="hover" placement="right">
                    <div v-html="`Quantity of single or panelized boards needed for the order.`"></div>
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <div class="numgroup">
                <el-popover ref="popover2" placement="right" width="300" trigger="click">
                  <div class="numberboxsty">
                    <ul class="clearfix">
                      <li class="trans-animate" v-for="(item, index) in dataMap.qty_list" :key="item.key"
                        :class="{ active: activeTag === index }" @click="numberChange2(item.value, index)">{{ item.value
                        }}
                      </li>
                    </ul>
                    <div class="clear"></div>
                    <p class="linetextsty">Select multiples of 5 in the blank of "Quantity: (pcs)" when your Single
                      layer/Double
                      layer PCB is larger than 10㎡. </p>
                    <ul class="submitsty">
                      <li>Other:</li>
                      <li><el-input v-model="form2.qty" style="width:76px"></el-input></li>
                      <li><el-button type="small" class="redcolor" @click="closePopover(2)">Submit</el-button></li>
                      <li><el-button type="small" @click="closePopover(2)">Cancel</el-button></li>
                    </ul>
                  </div>

                  <!-- <el-input v-model="form2.qty" class="input-with-select" style="width:200px" slot="reference" readonly>
                    <el-button slot="append">pcs</el-button>
                  </el-input> -->
                  
                  <div class="select-item-right" slot="reference">
                      <span class="span"><input placeholder="" v-model="form2.qty" type="text" readonly></span>
                      <span class="mm">pcs</span>
                    </div>
                </el-popover>
              </div>
              <!-- <div class="textsty">={{ form2.qty * 3 }}</div> -->
            </el-form-item>

            <!-- Break-away Rail -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <label class="red">*</label>
                  <span>
                    Break-away Rail
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="Rail at the edge of panel boards for fixing the panel boards on assembly machine more easily"
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <div class="numgroup">
                <div class="input-wrap">
                  <el-select v-model="form2.break_away_rail" placeholder="please input" style="width:145px">
                    <el-option v-for="item in dataMap.break_away_rail_list" :key="item.key" :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="input-wrap" v-if="form2.break_away_rail != 'N/A'">

                  <div class="select-item-right">
                    <span class="span"><input placeholder="" v-model="form2.break_away_rail_num" type="text" @input="break_away_rail_num_Change2"></span>
                    <span class="mm">mm</span>
                  </div>
                </div>
              </div>



            </el-form-item>
            <div class="line" style="margin-top:10px" v-if="form2.break_away_rail != 'N/A'">
              The minimum size is 3mm
            </div>
            <!-- PCB Thickness -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    PCB Thickness
                  </span>
                  <el-popover width="200" trigger="hover" class="item" content="The thickness of finished board."
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.pcb_thickness" class="custom-radio-group">
                <div class="radio-wrap" v-for="(pcbItem, index) in pcbList2" :key="'pcb_thickness' + index">
                  <el-radio :disabled="pcbItem.disabled" :label="pcbItem.value">{{ pcbItem.value }}</el-radio>
                  <img class="active-img" v-show="form2.pcb_thickness === pcbItem.value" src="./assets/gou.png">
                </div>
              </el-radio-group>
            </el-form-item>

            <!-- PCB Solder Mask Color -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    PCB Solder Mask Color
                  </span>
                  <el-popover width="200" trigger="hover" class="item" content="Color of the solder mask."
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <div class="numgroup">
                <el-radio-group v-model="form2.pcb_solder_mask_color" class="custom-radio-to-checkbox-group "
                  @change="changePcbSoldermaskColor2">
                  <div class="radio-wrap" v-for="item in dataMap.pcb_solder_mask_color_list" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value" border :class="'borderColor-' + item.key">{{
                      item.value
                    }}</el-radio>
                    <img class="active-img" v-show="form2.pcb_solder_mask_color === item.value"
                      src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </div>
            </el-form-item>
            <!-- Silkscreen -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Silkscreen
                  </span>
                  <el-popover width="200" trigger="hover" class="item" content="Color of the Silkscreen"
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <div class="numgroup">
                <el-radio-group v-model="form2.silkscreen" class="custom-radio-to-checkbox-group ">
                  <div class="radio-wrap" v-for="item in dataMap.silkscreen_list2" :key="item.key">
                    <el-radio :disabled="item.disabled" :label="item.value" border :class="'borderColor-' + item.key">{{
                      item.value
                    }}</el-radio>
                    <img class="active-img" v-show="form2.silkscreen === item.value" src="./assets/gou.png" />
                  </div>
                </el-radio-group>
              </div>
            </el-form-item>


            <!-- Electrical Test -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Electrical Test
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="We will do 100% electrical testing by flying probe and E-test machine."
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.electrical_test" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.electrical_test_list2" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.electrical_test === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>



            <!-- Finished Copper Weight -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Finished Copper Weight
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="Copper weight on the outer layers(top and bottom)." placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.finished_copper_weight" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.finished_copper_weight_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.finished_copper_weight === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>
            <div class="line" style="margin-top:10px" v-if="form2.finished_copper_weight == '2oz'">
              Impedance unavailable for Finished Copper thickness>=2 oz
            </div>

            <!-- PCB Inner Copper Weight -->
            <el-form-item class="form-item" v-if="pcb_inner_copper_weigh_show2">
              <template name="label">
                <div class="label-text">
                  <span>
                    PCB Inner Copper Weight
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="Copper weight on the outer layers(top and bottom)." placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.pcb_inner_copper_weigh" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.pcb_inner_copper_weigh_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.pcb_inner_copper_weigh === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>


            <!-- Min. Trace / Space Outer -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Min. Trace / Space Outer
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="The narrowest width of copper in the design for all external layers."
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.min_trace_space_outer" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.min_trace_space_outer_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.min_trace_space_outer === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>
            <!-- Min. Drilled Hole -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Min. Drilled Hole
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="The smallest drill size needed in the design" placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.mdh" class="custom-radio-group">
                <div class="radio-wrap" v-for="(mdhItem, index) in mdhList2" :key="'mdh' + index">
                  <el-radio :disabled="mdhItem.disabled" :label="mdhItem.value">{{ mdhItem.value }}</el-radio>
                  <img class="active-img" v-show="form2.mdh === mdhItem.value" src="./assets/gou.png">
                </div>
              </el-radio-group>
            </el-form-item>

            <!-- Via Process -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Via Process
                  </span>

                  <el-popover width="200" trigger="hover" placement="right">
                    <div v-html="`1. Tented vias (l-A/B): Vias are covered with solder mask oil. The level of solder mask oil
                        coverage depends on the diameter and depth of the hole. Holes larger than 0,45mm in diameter
                        cannot be fully covered.<br />
                        2,Opened vias: No via covering. Openings in the solder mask layer are added so the vias are
                        exposed and are treated with surface finish.For tented/opened vias, due to the difficulty in
                        differentiating vias and plated through-holes, if Gerber files are uploaded, the engineers will
                        follow the via design in the Gerber files directly, regardless of whether tented or open vias
                        were selected.<br />
                        3. Solder Mask Plug (lV-B): Vias plugged with solder mask, The vias are first filled with solder
                        mask and then covered with solder mask oil as with tented vias, This ensures all the vias are
                        plugged with solder mask oil but may still suffer from partial filling.<br />
                        4. Non-Conductive Fill & Cap (Vll): Vias are filled with non-conductive epoxy resin then
                        'capped' with copper pads, Suitable for via-in-pad deslgns.`"></div>
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.via_process" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.via_process_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}

                    <el-popover width="200" trigger="hover" placement="right" v-if="item.tips">
                      <div v-html="item.tips"></div>
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </el-radio>
                  <img class="active-img" v-show="form2.via_process === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>

            <!-- Surface Finish -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Surface Finish
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="The applied surface finish covering the exposed copper surface (solderable surfaces) of your PCB."
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.surface_finish" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.surface_finish_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}
                    <!-- <el-popover width="200" trigger="hover" class="item" :content="item.tips" placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover> -->
                  </el-radio>
                  <img class="active-img" v-show="form2.surface_finish === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>
            <!-- Thickness of Immersion Gold -->

            <el-form-item class="form-item" v-if="form2.surface_finish == 'ENIG'">
              <template name="label">
                <div class="label-text">
                  <span>
                    Thickness of Immersion Gold
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="The applied surface finish covering the exposed copper surface (solderable surfaces) of your PCB."
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.thickness_of_immersion_gold" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.thickness_of_immersion_gold_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.thickness_of_immersion_gold === item.value"
                    src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>
            <!-- Special Process -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Special Process
                  </span>
                </div>
              </template>
              <div class="numgroup">
                <el-checkbox-group v-model="form2.special_process" class="custom-checkbox-group"
                  @change="checkboxchange">

                  <div class="checkbox-wrap" v-for="(item) in dataMap.special_process_list" :key="item.key">
                    <el-checkbox :disabled="item.disabled" :label="item.label" :key="item.key" border>{{ item.value }}
                      <el-popover width="200" trigger="hover" placement="right" v-if="item.tips">
                        <div v-html="item.tips"></div>
                        <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                      </el-popover>
                    </el-checkbox>

                    <img class="active-img" v-show="form2.special_process.includes(item.value)"
                      src="./assets/gou.png" />
                  </div>
                </el-checkbox-group>
              </div>
            </el-form-item>

            <div class="line" style="margin-top:10px" v-if="form2.special_process.includes('Impedance')">
              No impedance control in default, if you choose impedance control, the lead time and price will be
              different.
            </div>
            <!-- HDI Structure -->
            <el-form-item class="form-item" v-if="form2.special_process.includes('HDI(Buried/blind vias)')">
              <template name="label">
                <div class="label-text">
                  <span>
                    HDI Structure
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content='lf your PCB board needs blind buried hole process, please choose the order according to your needs'
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.hdi_structure" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.hdi_structure_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.hdi_structure === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>
            <!-- Stack up -->

            <el-form-item class="form-item" v-if="Number(this.form2.layer_count) >= 4">
              <template name="label">
                <div class="label-text">
                  <span>
                    Stack up
                  </span>
                  <el-popover width="200" trigger="hover" placement="right">
                    <div v-html='`1. Select "No Requirement" when there is no impedance control;<br/>
2,Select "Customer Specified Stack up", additional fees will be charged;`'></div>
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.stack_up" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.stack_up_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.stack_up === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>
            <!-- X-out -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    X-out
                  </span>
                  <el-popover width="200" trigger="hover" class="item"
                    content="Crossed boards mean that there are 1PCS or more PCS scrapped boards in a set. Although the proportion is very low, there will inevitably be crossed boards. lf the crossed board is not accepted, the entire set of boards (Set) where it is located will need to be scrapped, which will increase the cost."
                    placement="top-start">
                    <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                  </el-popover>
                </div>
              </template>
              <el-radio-group v-model="form2.x_out" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.x_out_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.x_out === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>

            <!-- Personalized Service -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Personalized Service
                  </span>
                </div>
              </template>
              <div class="numgroup">
                <el-checkbox-group v-model="form2.personalized_service" class="custom-checkbox-group">
                  <div class="checkbox-wrap" v-for="(item, index) in dataMap.personalized_service_list" :key="item.key">
                    <el-checkbox :disabled="item.disabled" :label="item.label" :key="'personalized_service' + index"
                      border @change="(e) => personalizedServiceChange(e, item.value)">
                      {{ item.value }}
                      <el-popover width="200" trigger="hover" placement="right" v-if="item.tips">
                        {{ item.tips }}
                        <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                      </el-popover></el-checkbox>
                    <img class="active-img" v-show="form2.personalized_service.includes(item.value)"
                      src="./assets/gou.png" />
                  </div>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <div class="line" style="margin-top:10px"
              v-if="form2.personalized_service.includes('Delivery Report') || form2.personalized_service.includes('Microsection Analysis Report')">
              If you do not need a product report, you can remove the option
            </div>
            <!-- Report Format -->
            <el-form-item class="form-item"
              v-if="form2.personalized_service.includes('Delivery Report') || form2.personalized_service.includes('Microsection Analysis Report')">
              <template name="label">
                <div class="label-text">
                  <span>
                    Report Format
                  </span>
                </div>
              </template>
              <el-radio-group v-model="form2.report_format" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.report_format_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.report_format === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>

            <!-- UL Mark -->
            <el-form-item class="form-item" v-if="form2.personalized_service.includes('UL Mark')">
              <template name="label">
                <div class="label-text">
                  <span>
                    UL Mark
                  </span>
                </div>
              </template>
              <el-radio-group v-model="form2.ul_mark" class="custom-radio-group">
                <div class="radio-wrap" v-for="item in dataMap.ul_mark_list" :key="item.key">
                  <el-radio :disabled="item.disabled" :label="item.value">{{ item.value }}</el-radio>
                  <img class="active-img" v-show="form2.ul_mark === item.value" src="./assets/gou.png" />
                </div>
              </el-radio-group>
            </el-form-item>

            <!-- Add PO No. -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Add PO No.
                  </span>
                </div>
              </template>
              <div class="numgroup">
                <el-input v-model="form2.add_po_no" style="width:230px"></el-input>
              </div>
            </el-form-item>
            <!-- Special Requests -->
            <el-form-item class="form-item">
              <template name="label">
                <div class="label-text">
                  <span>
                    Special Requests
                  </span>
                </div>
              </template>
              <div class="numgroup" style="width:772px;height:217px;">
                <div class="inputsty">
                  <el-input type="textarea"
                    placeholder="Please fill in your special requirements for the PCB orde (within 500 characters)."
                    v-model="form2.special_requests" style="width:772px;height:217px;" maxlength="500" rows="5"></el-input>
                </div>
              </div>
            </el-form-item>
            <div>
            </div>
          </el-form>
        </div>
        <div class="pcba-contain1">
          <el-form ref="form3" :model="form3" :rules="rules3" label-position="left"
            class="formbox">
            <div class="bottomsty">
              <div class="refreshsty">
                <a @click="refreshFun3">
                  Reset
                </a>
              </div>
              <!-- Border Type -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Border Type
                    </span>
                  </div>
                </template>

                <el-radio-group v-model="form3.border_type" class="custom-radio-group" @change="borderTypeChange">
                  <div class="radio-wrap" v-for="item in dataMap.border_type_list" :key="item.key">
                    <el-radio :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form3.border_type === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Stencil Type -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Stencil Type
                    </span>
                    <el-popover width="200" trigger="hover" placement="right">
                      <div
                        v-html="`1. Stencil for Adhesives: First print the adhesives, then add the components,and after the components are firmly adhered to the PCB, the plug-in components are placed and wave soldered together:<br/>
2.Stencil for Solder Paste: Directhy print solder paste on the pad, paste the SMD components, and reflow soldering in a unified way, and the plug-in components are manually welded; <br/>
3. Step Down Stencil: Due to the different requirements for the amount of solder paste when welding various components on the PCB, ordinary laser stencils can only achieve the purpose of controlling the amount of solder paste through the size of the openings.`">
                      </div>
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form3.stencil_type" class="custom-radio-group">
                  <div class="radio-wrap" v-for="(item, index) in dataMap.stencil_type_list"
                    :key="'stencil_type' + index">
                    <el-radio :label="item.value" :disabled="item.disabled">{{ item.value }}
                      <el-popover width="200" trigger="hover" placement="right" v-if="item.tips">
                        <div v-html="item.tips"></div>
                        <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                      </el-popover>
                    </el-radio>
                    <img class="active-img" v-show="form3.stencil_type === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Printing Method -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Printing Method
                    </span>
                    <el-popover width="200" trigger="hover" placement="right">
                      <div v-html="`1. Fully automatic printing: Most of the fully automatic printed solder paste stencils use MARK point half a quarter;<br/>
2.Hand-printed and semi-automatically printed solder paste stencils can be used without MARK points.`"></div>
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form3.printing_method" class="custom-radio-group">
                  <div class="radio-wrap" v-for="item in dataMap.printing_method_list" :key="item.key">
                    <el-radio :label="item.value" :disabled="item.disabled">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form3.printing_method === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!--Size (mm)-->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Size (mm)
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="Please choose the size rules according to the size of the PCB (plate size) and the equipment used for the stencil. lf you have any questions about the size, please contact your exclusive salesman for confirmation."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <div class="numgroup">
                  <div class="input-wrap">
                    <el-select v-model="form3.size" placeholder="请选择" style="width:300px">
                      <el-option v-for="item in dataMap.size_list" :key="item.key" :label="item.value"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </el-form-item>

              <div class="line" style="margin-top:10px" v-if="form3.size=='300x400mm(Valid area 140x240mm)'||form3.size=='370x470mm(Valid area 190x290mm)'||form3.size=='280x380mm(Valid area 190x290mm)'||form3.size=='100x150mm(Valid area 100x150mm)'">
                Suitable for manual printing
              </div>
              <!-- Stencil Side -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Stencil Side
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="Depending on your PCB that how many side need to be soldered." placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form3.stencil_side" class="custom-radio-group" @change="stencilSideChange">
                  <div class="radio-wrap" v-for="(item, index) in dataMap.stencil_side_list"
                    :key="'stencil_side' + index">
                    <el-radio :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form3.stencil_side === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!--Quantity-->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Quantity
                    </span>
                  </div>
                </template>
                <div class="numgroup quantitysty">
                  <div id="pcbstencil-item-id6" class="select-item-right">
                    <span @click="countFun('+');" class="count span">+</span>
                    <span class="span"><input id="quantity-input" v-model="form3.quantity" style="text-align: center;"
                        type="text" value="1" /></span>
                    <span @click="countFun('-');" class="count span">-</span>
                    <span class="mm" style="margin-left:5px;">pcs</span>
                  </div>
                  <!-- <div class="input-wrap">
                <el-input-number v-model="form3.quantity"></el-input-number> pcs
              </div> -->
                </div>
              </el-form-item>

              <!-- Thickness  -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Thickness
                    </span>
                  </div>
                </template>
                <el-radio-group v-model="form3.thickness" class="custom-radio-group">
                  <div class="radio-wrap" v-for="(item, index) in dataMap.thickness_list" :key="'thickness' + index">
                    <el-radio :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form3.thickness === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>

              <!-- Existing Fiducials  -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Existing Fiducials
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="Fiducial Mark is an alignment mark for surface mount assembly machines.In General.machine assembly must have Fiducial marks.Fiducial marks are unnecessany when you are placing your parts by hand."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form3.existing_fiducials" class="custom-radio-group">
                  <div class="radio-wrap" v-for="(item, index) in dataMap.existing_fiducials_list"
                    :key="'existing_fiducials' + index">
                    <el-radio :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form3.existing_fiducials === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>
              <!-- Electropolishing   -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Electropolishing
                    </span>
                    <el-popover width="200" trigger="hover" class="item"
                      content="It is called BGA plating, is highly recommended for boards with BGAs or the pin to pin spacing on a lC is less thanequal to 0,5mm, as it will help the paste detach from the fine stencil apertures."
                      placement="top-start">
                      <i class="icon trans-animate vlm fs-xs quote-help" slot="reference">?</i>
                    </el-popover>
                  </div>
                </template>
                <el-radio-group v-model="form3.electropolishing" class="custom-radio-group">
                  <div class="radio-wrap" v-for="(item, index) in dataMap.electropolishing_list"
                    :key="'electropolishing' + index">
                    <el-radio :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form3.electropolishing === item.value" src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>
              <!-- Engineering Requirements   -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Engineering Requirements
                    </span>
                  </div>
                </template>
                <el-radio-group v-model="form3.engineering_requirements" class="custom-radio-group">
                  <div class="radio-wrap" v-for="(item, index) in dataMap.engineering_requirements_list"
                    :key="'engineering_requirements' + index">
                    <el-radio :label="item.value">{{ item.value }}</el-radio>
                    <img class="active-img" v-show="form3.engineering_requirements === item.value"
                      src="./assets/gou.png">
                  </div>
                </el-radio-group>
              </el-form-item>
              <!-- Add PO No.  -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Add PO No.
                    </span>
                  </div>
                </template>
                <div class="numgroup">
                  <el-input v-model="form3.stencil_add_po_no" style="width:230px"></el-input>
                </div>
              </el-form-item>

              <!-- Special Requests -->
              <el-form-item class="form-item">
                <template name="label">
                  <div class="label-text">
                    <span>
                      Special Requests
                    </span>
                  </div>
                </template>
                <div class="numgroup">
                  <div class="inputsty">
                    <el-input type="textarea"
                      placeholder="Please fill in your special requirements for the PCB orde (within 500 characters)."
                      v-model="form3.stencil_special_requests" style="width: 750px;" maxlength="500"
                      rows="5"></el-input>
                  </div>
                </div>
              </el-form-item>

      
              <div class="access-div">
                <div class="submit-items">
                  <h2 class="h2"><span class="red">*</span>Company</h2>
                  <div class="mt10">
                    <input placeholder="Company" v-model="form3.company" class="submit-input" type="text" name=""
                      value="">
                  </div>
                </div>

                <div class="submit-items">
                  <h2 class="h2"><span class="red">*</span>Name</h2>
                  <div class="mt10">
                    <input placeholder="Name" v-model="form3.name" class="submit-input" type="text" name="" value="">
                  </div>
                </div>

                <div class="submit-items">
                  <h2 class="h2"><span class="red">*</span>E-mail</h2>
                  <div class="mt10">
                    <input placeholder="E-mail" v-model="form3.email" class="submit-input" type="text" name="" value="">
                  </div>
                </div>

                <div class="clear"></div>

                <a href="javascript:;" class="submit-form-btn" @click="onSubmit2">SUBMIT</a>
              </div>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="Rules" :visible.sync="ruleTextVisible" width="50%" center>
      <div class="dl-text">
        <div>1. To keep the accuracy of your Gerber file for manufacturing and avoid component losses originating from
          the
          PCB
          end, welllink will conduct a final inspection on potential issues of the circuit layer, solder mask layer,
          silkscreen layer, outline layer, inner slot, and layer sequence in the file.
        </div>
        <div>2. Working Gerber will be completed within 4 hours after Gerber File uploaded. When it comes to holidays or
          non-business hours, the completion time will have a delay.
        </div>
        <div>3. If there are mistakes in the Working Gerber, our sales will contact you to solve it as soon as possible
          and get your approval before manufacturing, we will not arrange production if we fail to get your approval.
        </div>
        <div>4. The original lead time of your order is for your reference and is recalculated according to when you
          approve Working Gerber.
        </div>
        <div>5. If you do not accept "Approve Working Gerber", we will assume that you do not need this step before
          manufacturing by default.
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ruleTextVisible = false">Accept</el-button>
        <el-button @click="decline">Decline</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { layerCountList } from './utils';
import { inquiry_pcba_save, upload } from './api/index'

export default {
  data() {
    return {
      ruleTextVisible: false,
      tableData: [
        {
          id: '1',
          designator: 'C1,C2,C3,C4',
          qty: '4',
          manufacturerPartNumber: 'MFR3WSFTE 73-2K',
          customerSupply: '--',
          customerRemark: '--',
        },
        {
          id: '2',
          designator: 'D1,D2',
          qty: '2',
          manufacturerPartNumber: '1H104ZC4P-3F-ZNR',
          customerSupply: '--',
          customerRemark: '--',
        },
        {
          id: '3',
          designator: 'B2-B9',
          qty: '8',
          manufacturerPartNumber: 'CC 81-N5U2J1B220KSEW',
          customerSupply: 'Y',
          customerRemark: '--',
        },
        {
          id: '4',
          designator: 'A1',
          qty: '1',
          manufacturerPartNumber: 'LD1117V33',
          customerSupply: 'DNP',
          customerRemark: '--',
        },
      ],
      checkboxGroup1: [],
      checkedValues: [], // 存储选中的值
      options: [
        { label: '选项A', value: 'A' },
        { label: '选项B', value: 'B' },
        { label: '选项C', value: 'C' }
      ],
      fileListGerber2: [],
      fileListGerber: [],
      fileListBom: [],
      fileListCoordinate: [],

      fileNameGerber2: '',
      fileNameGerber: '',
      fileNameBom: '',
      fileNameCoordinate: '',

      uploadProgressGerber2: 0,
      uploadProgressGerber: 0,
      uploadProgressBom: 0,
      uploadProgressCoordinate: 0,

      isUploadDisabledGerber: false,
      isUploadDisabledGerber2: false,
      isUploadDisabledBOM: false,
      isUploadDisabledCoordinate: false,


      showTG: false,
      showTG2: false,
      dataMap: {
        material_type_list: [
          {
            key: "Fr-4",
            value: "Fr-4",
          }
        ],
        layerCountList,
        TGList: [
          {
            key: 'TG130',
            value: 'TG130',
            disabled: true
          },
          {
            key: 'TG150',
            value: 'TG130',
            disabled: true
          },
          {
            key: 'TG170',
            value: 'TG130',
            disabled: true
          }
        ],
        board_type_list: [
          {
            key: 'Single piece',
            label: 'Single piece',
            value: 'Single piece',
            disabled: false
          },
          {
            key: 'Panel by Customer',
            label: 'Panel by Customer',
            value: 'Panel by Customer',
            disabled: false
          },
          {
            key: 'Panel by welllink',
            label: 'Panel by welllink',
            value: 'Panel by welllink',
            disabled: false
          }
        ],
        qty_list: [
          {
            key: "qty5",
            value: 5,
          },
          {
            key: "qty10",
            value: 10,
          },
          {
            key: "qty15",
            value: 15,
          },
          {
            key: "qty20",
            value: 20,
          },
          {
            key: "qty25",
            value: 25,
          },
          {
            key: "qty30",
            value: 30,
          },
          {
            key: "qty40",
            value: 40,
          },
          {
            key: "qty50",
            value: 50,
          },
          {
            key: "qty75",
            value: 75,
          },
          {
            key: "qty100",
            value: 100,
          },
          {
            key: "qty125",
            value: 125,
          },
          {
            key: "qty150",
            value: 150,
          },
          {
            key: "qty200",
            value: 200,
          },
          {
            key: "qty250",
            value: 250,
          },
          {
            key: "qty300",
            value: 300,
          },
          {
            key: "qty350",
            value: 350,
          },
          {
            key: "qty400",
            value: 400,
          },
          {
            key: "qty450",
            value: 450,
          },
          {
            key: "qty500",
            value: 500,
          },
          {
            key: "qty600",
            value: 600,
          },
          {
            key: "qty700",
            value: 700,
          },
          {
            key: "qty800",
            value: 800,
          },
          {
            key: "qty900",
            value: 900,
          },
          {
            key: "qty1000",
            value: 1000,
          },
          {
            key: "qty1500",
            value: 1500,
          },
          {
            key: "qty2000",
            value: 2000,
          },
          {
            key: "qty2500",
            value: 2500,
          },
          {
            key: "qty3000",
            value: 3000,
          },
          {
            key: "qty3500",
            value: 3500,
          },
          {
            key: "qty4000",
            value: 4000,
          },
          {
            key: "qty4500",
            value: 4500,
          },
          {
            key: "qty5000",
            value: 5000,
          },
          {
            key: "qty5500",
            value: 5500,
          },
          {
            key: "qty6000",
            value: 6000,
          },
          {
            key: "qty6500",
            value: 6500,
          },
          {
            key: "qty7000",
            value: 7000,
          },
          {
            key: "qty7500",
            value: 7500,
          },
          {
            key: "qty8000",
            value: 8000,
          },
          {
            key: "qty9000",
            value: 9000,
          },
          {
            key: "qty10000",
            value: 10000,
          }
        ],

        break_away_rail_list: [
          {
            key: "break_away_rail_null_all",
            label: "break_away_rail_null_all",
            value: "N/A",
          },
          {
            key: "break_away_rail_Left_Right",
            label: "break_away_rail_Left_Right",
            value: "Left & Right",
          },
          {
            key: "break_away_rail_Top_Bottom",
            label: "break_away_rail_Top_Bottom",
            value: "Top & Bottom",
          },
          {
            key: "break_away_rail_All_4sides",
            label: "break_away_rail_All_4sides",
            value: "All 4 sides",
          },
        ],
        pcb_solder_mask_color_list: [
          {
            key: "green",
            label: "Green",
            value: "Green",
          },
          {
            key: "red",
            label: "Red",
            value: "Red",
          },
          {
            key: "yellow",
            label: "Yellow",
            value: "Yellow",
          },
          {
            key: "blue",
            label: "Blue",
            value: "Blue",
          },
          {
            key: "white",
            label: "White",
            value: "White",
          },
          {
            key: "matte-black",
            label: "Matte Black",
            value: "Matte Black",
          },
          {
            key: "black",
            label: "Black",
            value: "Black",
          },
        ],
        silkscreen_list: [
          {
            key: "white",
            label: "White",
            value: "White",
            disabled: false
          },
          {
            key: "black",
            label: "Black",
            value: "Black",
            disabled: true
          }
        ],
        silkscreen_list2: [
          {
            key: "white",
            label: "White",
            value: "White",
            disabled: false
          },
          {
            key: "black",
            label: "Black",
            value: "Black",
            disabled: true
          }
        ],
        electrical_test_list: [
          {
            key: "Sample_Test_Free",
            label: "Sample Test Free",
            value: "Sample Test Free",
          }
        ],
        electrical_test_list2: [
          {
            key: "Sample_Test_Free",
            label: "Sample Test Free",
            value: "Sample Test Free",
          }
        ],
        finished_copper_weight_list: [
          {
            key: "1oz",
            label: "1oz",
            value: "1oz",
          },
          {
            key: "2oz",
            label: "2oz",
            value: "2oz",
          }],
        pcb_inner_copper_weigh_list: [
          {
            key: "0.5oz",
            label: "0.5oz",
            value: "0.5oz",
          },
          {
            key: "1oz",
            label: "1oz",
            value: "1oz",
          },
          {
            key: "2oz",
            label: "2oz",
            value: "2oz",
          }],
        min_trace_space_outer_list: [
          {
            key: "min_trace_space_outer_list10",
            label: "10/10mil↑",
            value: "10/10mil↑",
          },
          {
            key: "min_trace_space_outer_list8",
            label: "8/8mil↑",
            value: "8/8mil↑",
          },
          {
            key: "min_trace_space_outer_list6",
            label: "6/6mil↑",
            value: "6/6mil↑",
          },
          {
            key: "min_trace_space_outer_list5",
            label: "5/5mil",
            value: "5/5mil",
          },
          {
            key: "min_trace_space_outer_list4",
            label: "4/4mil",
            value: "4/4mil",
          },
          {
            key: "min_trace_space_outer_list3_5",
            label: "3.5/3.5mil",
            value: "3.5/3.5mil",
            disabled: true
          }
        ],
        via_process_list: [
          {
            key: "tenting_vias",
            label: "Tenting Vias",
            value: "Tenting Vias",
            tips: "1.For Gerber files, whether vias are tented or not covered will depend on the via design in the Gerber files<br/>2.For tented wlas,solder must not adhere to vias to pass quality control. Vias may appear orange from solder mask thinning but this is normal."
          },
          {
            key: "vias_not_covered",
            label: "Vias not covered",
            value: "Vias not covered",
            tips: "For Gerber files, whether vias are tented or not covered will depend on the via design in the Gerber files"
          },
          {
            key: "solder_mask_plug",
            label: "Solder Mask Plug (IV-B)",
            value: "Solder Mask Plug (IV-B)",
            tips: "For tented vias, there is a risk solder beads will get lodged inside during wave soldering or HASL processing. Solder Mask Plugged (IV-B) via processing can be selected to prevent this."
          },
          {
            key: "non-conductive_fill&Cap",
            label: "Non-Conductive Fill & Cap (VII)",
            value: "Non-Conductive Fill & Cap (VII)",
            tips: '1.If your design contains vias in pads (especially for BGAs) we strongly recommend Non-Conductive Fill & Cap(Vll) via processing.<br/>2. Without filling and capping, the surface of the pad will be uneven and solder may leak into the via barrel, reducing the amount of solder available to form solder joints. We will not be held responsible for defects caused by not capping vias.'
          },
        ],
        surface_finish_list: [
          {
            key: "HASL",
            label: "HASL",
            value: "HASL",
            // tips: "1.For Gerber files, whether vias aretented or not covered will depend onthe via design in the Gerber files<br/>2.For tented wlas,solder must notadhere to vias to pass quality controlVias may appear orange from soldermask thinning but this is normal."
          },
          {
            key: "Lead free HASL",
            label: "Lead free HASL",
            value: "Lead free HASL",
            // tips: "For Gerber files, whether vias aretented or not covered will depend onthe via design in the Gerber files"
          },
          {
            key: "ENIG",
            label: "ENIG",
            value: "ENIG",
            // tips: "For tented vias, there is a risk solde!beads will get lodged inside duringwave soldering or HASL processingSolder Mask Plugged (IV-B) viaprocessing can be selected toprevent this."
          },
          {
            key: "OSP",
            label: "OSP",
            value: "OSP",
            // tips: "1.If your design contains vias in pads(especially for BGAs) we stronglyrecommend Non-Conductive Fill &Cap(Vll) via processing.2. Without filling and capping, thesurface of the pad will be unevenand solder may leak into the viabarrel, reducing the amount of solderavailable to form solder joints. Wewill not be held responsible fordefects caused by not capping vias"
          },
        ],
        thickness_of_immersion_gold_list: [
          {
            key: "thickness_of_immersion_gold1",
            label: "1μ″",
            value: "1μ″",
          },
          {
            key: "thickness_of_immersion_gold2",
            label: "2μ″",
            value: "2μ″",
          },
          {
            key: "thickness_of_immersion_gold3",
            label: "3μ″",
            value: "3μ″",
          },
        ],
        special_process_list: [
          {
            disabled: true,
            key: "hdi",
            label: "HDI(Buried/blind vias)",
            value: "HDI(Buried/blind vias)",
            tips: `Blind buried holes are the guide holes that connect the surface layer and the inner layer but not through the whole board, buried holes are the inner layer over holes, the surface bottom layer is invisible, for the inner layer signal connection.Note:HDl PCB is only applicable to 4-layer board or above`
          },
          {
            key: "impedance",
            label: "Impedance",
            value: "Impedance",
            tips: `For designs that require tight control on the circuit impedance including modeling and verification testing.`
          },
          {
            key: "beveling_of_gf",
            label: "Beveling of G/F",
            value: "Beveling of G/F",
            tips: `For the convenience of plug-in and plug-out of gold finger, the side of the board will usually be beveled. The bevealing angle is 45 degrees.`

          },
          {
            key: "plated_half_holes_castellated_holes",
            label: "Plated Half-holes/ Castellated Holes",
            value: "Plated Half-holes/ Castellated Holes",
            tips: `Half of the drilled hole or slot is inside the board, and the other is outside the shape of the board. After the plate is shaped, the wall of the drilled hole or slot still should be covered in copper. Plating refers to the edge plating. Plated Half-holes/Plated Through Hole doesn't support HAL temporarily.`
          },
        ],
        hdi_structure_list: [
          {
            key: "Rank 1",
            label: "Rank 1",
            value: "Rank 1",
          },
          {
            key: "Rank 2",
            label: "Rank 2",
            value: "Rank 2",
          },
          {
            key: "Rank 3",
            label: "Rank 3",
            value: "Rank 3",
          },
        ],
        stack_up_list: [
          {
            key: "No_Requirement",
            label: "No Requirement",
            value: "No Requirement",
          },
          {
            key: "Customer_Specified_Stack_up",
            label: "Customer Specified Stack up",
            value: "Customer Specified Stack up",
          },
        ],
        x_out_list: [
          {
            key: "accepts",
            label: "Accepts",
            value: "Accepts",
          },
          {
            key: "not_accepting",
            label: "Not accepting",
            value: "Not accepting",
          },
        ],
        personalized_service_list: [
          {
            key: "approve_working_gerber",
            label: "Approve Working Gerber",
            value: "Approve Working Gerber",
          },
          {
            key: "delivery_report",
            label: "Delivery Report",
            value: "Delivery Report",
            tips: `hipping report: includes appearance/size/open short circuit/reliabilitytest`,
          },

          {
            key: "microsection_analysis_report",
            label: "Microsection Analysis Report",
            value: "Microsection Analysis Report",
            tips: `Slice report: including surface copper / hole copper /dielectric layer thickness /internal characteristics of the plate test`
          },
          {
            key: "ul_mark",
            label: "UL Mark",
            value: "UL Mark",
            tips: `UL logo selection default for UL +week / year, if you do not choose,we will default to you do not need, please choose according to your needs.`
          },
        ],
        report_format_list: [
          {
            key: "paper",
            label: "Paper",
            value: "Paper",
          },
          {
            key: "electronic",
            label: "Electronic",
            value: "Electronic",
          },
        ],
        ul_mark_list: [
          {
            key: "UL_Week_Year",
            label: "UL+Week/Year",
            value: "UL+Week/Year",
          },
          {
            key: "UL_Year_Week",
            label: "UL+Year/Week",
            value: "UL+Year/Week",
          },
        ],
        border_type_list: [
          {
            key: "framework",
            label: "Framework",
            value: "Framework",
          },
          {
            key: "non_framework",
            label: "Non-framework",
            value: "Non-framework",
          },
        ],
        stencil_type_list: [
          {
            key: "stencil_for_solder_paste",
            label: "Stencil for Solder Paste",
            value: "Stencil for Solder Paste",
          },
          {
            key: "stencil_for_adhesive",
            label: "Stencil for Adhesive",
            value: "Stencil for Adhesive",
            tips: `<img src="${require('../src/assets/images/img_01.png')}" alt="" />`
          },
          {
            key: "step_down_stencil",
            label: "Step Down Stencil",
            value: "Step Down Stencil",
            tips: `<img src="${require('../src/assets/images/img_01.png')}" alt="" />`
          }
        ],
        printing_method_list: [
          {
            key: "semiautomaticprinting",
            label: "Semi-automatic Printing",
            value: "Semi-automatic Printing",
            disabled: true
          },
          {
            key: "fullyautomaticprinting",
            label: "Fully Automatic Printing",
            value: "Fully Automatic Printing",
            disabled: true
          },
          {
            key: "manualprinting",
            label: "Manual Printing",
            value: "Manual Printing",
          },
        ],


        size_list: [
          {
            label: "300x400mm(Valid area 140x240mm)",
            value: "300x400mm(Valid area 140x240mm)",
          },
          {
            label: "370x470mm(Valid area 190x290mm)",
            value: "370x470mm(Valid area 190x290mm)",
          },
          {
            label: "420x520mm(Valid area 240x340mm)",
            value: "420x520mm(Valid area 240x340mm)",
          },
          {
            label: "450x550mm(Valid area 270x370mm)",
            value: "450x550mm(Valid area 270x370mm)",
          },
          {
            label: "584x584mm(Valid area 380x380mm)",
            value: "584x584mm(Valid area 380x380mm)",
          },
          {
            label: "550x650mm(Valid area 350x450mm)",
            value: "550x650mm(Valid area 350x450mm)",
          },
          {
            label: "736x736mm(Valid area 500x500mm)",
            value: "736x736mm(Valid area 500x500mm)",
          },
          {
            label: "400x600mm(Valid area 220x400mm)",
            value: "400x600mm(Valid area 220x400mm)",
          },
          {
            label: "400x800mm(Valid area 220x600mm)",
            value: "400x800mm(Valid area 220x600mm)",
          },
          {
            label: "400x1000mm(Valid area 220x760mm)",
            value: "400x1000mm(Valid area 220x760mm)",
          },
          {
            label: "400x1200mm(Valid area 220x1000mm)",
            value: "400x1200mm(Valid area 220x1000mm)",
          },
          {
            label: "400x1400mm(Valid area 220x1200mm)",
            value: "400x1400mm(Valid area 220x1200mm)",
          },
          {
            label: "500x700mm(Valid area 320x500mm)",
            value: "500x700mm(Valid area 320x500mm)",
          },
          {
            label: "500x1200mm(Valid area 320x600mm)",
            value: "500x1200mm(Valid area 320x600mm)",
          },
          {
            label: "500x800mm(Valid area 320x1300mm)",
            value: "500x800mm(Valid area 320x1300mm)",
          }
        ],
        size_list1: [
          {
            label: "300x400mm(Valid area 140x240mm)",
            value: "300x400mm(Valid area 140x240mm)",
          },
          {
            label: "370x470mm(Valid area 190x290mm)",
            value: "370x470mm(Valid area 190x290mm)",
          },
          {
            label: "420x520mm(Valid area 240x340mm)",
            value: "420x520mm(Valid area 240x340mm)",
          },
          {
            label: "450x550mm(Valid area 270x370mm)",
            value: "450x550mm(Valid area 270x370mm)",
          },
          {
            label: "584x584mm(Valid area 380x380mm)",
            value: "584x584mm(Valid area 380x380mm)",
          },
          {
            label: "550x650mm(Valid area 350x450mm)",
            value: "550x650mm(Valid area 350x450mm)",
          },
          {
            label: "736x736mm(Valid area 500x500mm)",
            value: "736x736mm(Valid area 500x500mm)",
          },
          {
            label: "400x600mm(Valid area 220x400mm)",
            value: "400x600mm(Valid area 220x400mm)",
          },
          {
            label: "400x800mm(Valid area 220x600mm)",
            value: "400x800mm(Valid area 220x600mm)",
          },
          {
            label: "400x1000mm(Valid area 220x760mm)",
            value: "400x1000mm(Valid area 220x760mm)",
          },
          {
            label: "400x1200mm(Valid area 220x1000mm)",
            value: "400x1200mm(Valid area 220x1000mm)",
          },
          {
            label: "400x1400mm(Valid area 220x1200mm)",
            value: "400x1400mm(Valid area 220x1200mm)",
          },
          {
            label: "500x700mm(Valid area 320x500mm)",
            value: "500x700mm(Valid area 320x500mm)",
          },
          {
            label: "500x1200mm(Valid area 320x600mm)",
            value: "500x1200mm(Valid area 320x600mm)",
          },
          {
            label: "500x800mm(Valid area 320x1300mm)",
            value: "500x800mm(Valid area 320x1300mm)",
          }
        ],

        size_list2: [
          {
            label: "280x380mm(Valid area 190x290mm)",
            value: "280x380mm(Valid area 190x290mm)",
          },
          {
            label: "100x150mm(Valid area 100x150mm)",
            value: "100x150mm(Valid area 100x150mm)",
          },
        ],
        stencil_side_list: [
          {
            label: "Top",
            value: "Top",
          },
          {
            label: "Bottom",
            value: "Bottom",
          },
          {
            label: "Top & Bottom",
            value: "Top & Bottom",
          },
          {
            label: "Top & Bottom ( Different Solder Paste )",
            value: "Top & Bottom ( Different Solder Paste )",
          },
        ],
        thickness_list: [
          {
            label: "0.10mm",
            value: "0.10mm",
          },
          {
            label: "0.12mm",
            value: "0.12mm",
          },
          {
            label: "0.15mm",
            value: "0.15mm",
          },
          {
            label: "0.20mm",
            value: "0.20mm",
          },
        ],
        existing_fiducials_list: [
          {
            label: "None",
            value: "None",
          },
          {
            label: "Half lasered",
            value: "Half lasered",
          },
          {
            label: "Lasered through",
            value: "Lasered through",
          },
        ],
        electropolishing_list: [
          {
            label: "Grinding and Polishing",
            value: "Grinding and Polishing",
          },
          {
            label: "Electropolishing",
            value: "Electropolishing",
          },
        ],
        engineering_requirements_list: [
          {
            label: "welllink specification",
            value: "welllink specification",
          },
          {
            label: "Confirm by customer",
            value: "Confirm by customer",
          },
        ],
      },
      activeTag: null,
      pcb_inner_copper_weigh_show: false,
      pcb_inner_copper_weigh_show2: false,
      form: {
        inquiry_pcba_type: '2',
        material_type: "Fr-4",
        layer_count: "2",
        tg: "TG130",
        board_type: "Single piece",
        size_one: null,
        size_two: null,
        qty: null,
        mdh: "0.3mm↑",
        break_away_rail: 'N/A',
        break_away_rail_num: null,
        pcb_thickness: "1.6",
        pcb_solder_mask_color: 'Green',
        silkscreen: 'White',
        electrical_test: 'Sample Test Free',
        finished_copper_weight: '1oz',
        pcb_inner_copper_weigh: '0.5oz',
        min_trace_space_outer: '6/6mil↑',
        min_drilled_hole: '',
        via_process: 'Tenting Vias',
        surface_finish: 'HASL',
        thickness_of_immersion_gold: '1μ″',
        special_process: [],
        special_process_arr: ['Impedance'],
        hdi_structure: 'Rank 1',
        stack_up: 'No Requirement',
        x_out: 'Accepts',
        personalized_service: [],
        personalized_service_arr: [],
        report_format: 'Paper',
        ul_mark: 'UL+Week/Year',
        add_po_no: '',
        special_requests: '',
        border_type: 'Framework',
        stencil_type: 'Stencil for Solder Paste',
        printing_method: 'Manual Printing',
        size: '300x400mm(Valid area 140x240mm)',
        stencil_side: 'Top',
        quantity: '1',
        thickness: '0.10mm',
        existing_fiducials: 'None',
        electropolishing: 'Grinding and Polishing',
        engineering_requirements: 'welllink specification',
        stencil_add_po_no: '',
        stencil_special_requests: '',
        original_gerber_url: '',
        original_gerber_name: '',
        original_bom_url: '',
        original_bom_name: '',
        original_coordinate_url: '',
        original_coordinate_name: '',
        name: '',
        company: '',
        email: '',
        checkAddPCB: false,
        pcba_qty: ''
      },
      pcba_qty: '',
      form2: {
        material_type: "Fr-4",
        layer_count: "2",
        tg: "TG130",
        board_type: "Single piece",
        size_one: null,
        size_two: null,
        qty: null,
        mdh: "0.3mm↑",
        break_away_rail: 'N/A',
        break_away_rail_num: null,
        pcb_thickness: "1.6",
        pcb_solder_mask_color: 'Green',
        silkscreen: 'White',
        electrical_test: 'Sample Test Free',
        finished_copper_weight: '1oz',
        pcb_inner_copper_weigh: '0.5oz',
        min_trace_space_outer: '6/6mil↑',
        min_drilled_hole: '',
        via_process: 'Tenting Vias',
        surface_finish: 'HASL',
        thickness_of_immersion_gold: '1μ″',
        special_process: [],
        special_process_arr: ['Impedance'],
        hdi_structure: 'Rank 1',
        stack_up: 'No Requirement',
        x_out: 'Accepts',
        personalized_service: [],
        personalized_service_arr: [],
        report_format: 'Paper',
        ul_mark: 'UL+Week/Year',
        add_po_no: '',
        special_requests: '',
        original_gerber_url: '',
        original_gerber_name: '',
        original_bom_url: '',
        original_bom_name: '',
        original_coordinate_url: '',
        original_coordinate_name: '',

      },
      form3: {
        border_type: 'Framework',
        stencil_type: 'Stencil for Solder Paste',
        printing_method: 'Manual Printing',
        size: '300x400mm(Valid area 140x240mm)',
        stencil_side: 'Top',
        quantity: '1',
        thickness: '0.10mm',
        existing_fiducials: 'None',
        electropolishing: 'Grinding and Polishing',
        engineering_requirements: 'welllink specification',
        stencil_add_po_no: '',
        stencil_special_requests: '',
        name: '',
        company: '',
        email: '',
      },
      inquiry_pcba_type: '1',
      url: {
        original_gerber_url: '',
        original_gerber_name: '',
        original_bom_url: '',
        original_bom_name: '',
        original_coordinate_url: '',
        original_coordinate_name: '',
      },
      rules: {
        size_one: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        size_two: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        qty: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        company: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        name: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
      },
      rules2: {
        size_one: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        size_two: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        qty: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
      },
      rules3: {
        company: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        name: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'please input', trigger: 'blur' },
        ],
      },
      errorMessage: '',
    };
  },
  watch: {
    qty(newValue, oldValue) {
      // 当inputValue变化时，这个函数会被调用
      // 你可以在这里添加更多的逻辑
    }
  },
  computed: {
    pcbList() {
      return this.dataMap.layerCountList.filter(i => i.key === this.form.layer_count)[0].pcb;
    },
    pcbList2() {
      return this.dataMap.layerCountList.filter(i => i.key === this.form2.layer_count)[0].pcb;
    },
    mdhList() {
      const mdhList = this.pcbList.filter(i => i.value === this.form.pcb_thickness)[0] || {}
      return mdhList.mdh;
    },
    mdhList2() {
      const mdhList2 = this.pcbList2.filter(i => i.value === this.form2.pcb_thickness)[0] || {};
      return mdhList2.mdh;
    }
  },
  methods: {
    break_away_rail_num_Change(event){
      const obj  = event.target
      obj.value = obj.value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符  
      obj.value = obj.value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的  
      obj.value = obj.value.replace(".","$#$").replace(/\./g,"").replace("$#$","."); 
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数  
      if(obj.value.indexOf(".")< 0 && obj.value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
          obj.value= parseFloat(obj.value); 
      } 
      this.form.break_away_rail_num = obj.value; 
    },
    break_away_rail_num_Change2(event){
      const obj  = event.target
      obj.value = obj.value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符  
      obj.value = obj.value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的  
      obj.value = obj.value.replace(".","$#$").replace(/\./g,"").replace("$#$","."); 
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数  
      if(obj.value.indexOf(".")< 0 && obj.value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
          obj.value= parseFloat(obj.value); 
      } 
      this.form2.break_away_rail_num = obj.value; 
    },
    
    size_one_Change(event){
      const obj  = event.target
      obj.value = obj.value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符  
      obj.value = obj.value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的  
      obj.value = obj.value.replace(".","$#$").replace(/\./g,"").replace("$#$","."); 
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数  
      if(obj.value.indexOf(".")< 0 && obj.value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
          obj.value= parseFloat(obj.value); 
      } 
      this.form.size_one = obj.value; 
    },
    size_one_Change2(event){
      const obj  = event.target
      obj.value = obj.value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符  
      obj.value = obj.value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的  
      obj.value = obj.value.replace(".","$#$").replace(/\./g,"").replace("$#$","."); 
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数  
      if(obj.value.indexOf(".")< 0 && obj.value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
          obj.value= parseFloat(obj.value); 
      } 
      this.form2.size_one = obj.value; 
    },
    size_two_Change(event){
      const obj  = event.target
      obj.value = obj.value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符  
      obj.value = obj.value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的  
      obj.value = obj.value.replace(".","$#$").replace(/\./g,"").replace("$#$","."); 
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数  
      if(obj.value.indexOf(".")< 0 && obj.value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
          obj.value= parseFloat(obj.value); 
      } 
      this.form.size_two = obj.value; 
    },
    size_two_Change2(event){
      const obj  = event.target
      obj.value = obj.value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符  
      obj.value = obj.value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的  
      obj.value = obj.value.replace(".","$#$").replace(/\./g,"").replace("$#$","."); 
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数  
      if(obj.value.indexOf(".")< 0 && obj.value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
          obj.value= parseFloat(obj.value); 
      } 
      this.form2.size_two = obj.value; 
    },
    countFun(type) {
      var v = Number(this.form3.quantity);
      if (type == "+") {
        v = v + 1;
      }
      else {
        if (v > 0) {
          v = v - 1;
        }
      }
      this.form3.quantity = v
    },
    personalizedServiceChange(e, val) {
      if (e && val === 'Approve Working Gerber') {
        this.ruleTextVisible = true;
      }
    },
    decline() {
      if (this.form.inquiry_pcba_type === '2') {
        // const personalized_service=this.form2.personalized_service;
        this.form.personalized_service = this.form.personalized_service.filter(item => {
          return item != 'Approve Working Gerber'
        })
      } else {
        // const personalized_service=this.form2.personalized_service;
        this.form2.personalized_service = this.form2.personalized_service.filter(item => {
          return item != 'Approve Working Gerber'
        })
      }
      this.ruleTextVisible = false;

    },
    refreshFun1() {
      this.showTG = false;
      this.form = {
        inquiry_pcba_type: '1',
        material_type: "Fr-4",
        layer_count: "2",
        tg: "TG130",
        board_type: "Single piece",
        size_one: null,
        size_two: null,
        qty: null,
        mdh: "0.3mm↑",
        break_away_rail: 'N/A',
        break_away_rail_num: null,
        pcb_thickness: "1.6",
        pcb_solder_mask_color: 'Green',
        silkscreen: 'White',
        electrical_test: 'Sample Test Free',
        finished_copper_weight: '1oz',
        pcb_inner_copper_weigh: '0.5oz',
        min_trace_space_outer: '6/6mil↑',
        min_drilled_hole: '',
        via_process: 'Tenting Vias',
        surface_finish: 'HASL',
        thickness_of_immersion_gold: '1μ″',
        special_process: [],
        special_process_arr: ['Impedance'],
        hdi_structure: 'Rank 1',
        stack_up: 'No Requirement',
        x_out: 'Accepts',
        personalized_service: [],
        personalized_service_arr: [],
        report_format: 'Paper',
        ul_mark: 'UL+Week/Year',
        add_po_no: '',
        special_requests: '',
        border_type: 'Framework',
        stencil_type: 'Stencil for Solder Paste',
        printing_method: 'Manual Printing',
        size: '300x400mm(Valid area 140x240mm)',
        stencil_side: 'Top',
        quantity: '1',
        thickness: '0.10mm',
        existing_fiducials: 'None',
        electropolishing: 'Grinding and Polishing',
        engineering_requirements: 'welllink specification',
        stencil_add_po_no: '',
        stencil_special_requests: '',
        original_gerber_url: '',
        original_gerber_name: '',
        original_bom_url: '',
        original_bom_name: '',
        original_coordinate_url: '',
        original_coordinate_name: '',
        name: '',
        company: '',
        email: '',
        checkAddPCB: false,
        pcba_qty: ''
      };
      this.onRemoveGerber();
      this.onRemoveBom();
      this.onRemoveCoordinate();
      this.changePcbSoldermaskColor('Green');
      this.changeLayerCount('2')
    },
    refreshFun2() {
      this.showTG2 = false;
      this.form2 = {
        material_type: "Fr-4",
        layer_count: "2",
        tg: "TG130",
        board_type: "Single piece",
        size_one: null,
        size_two: null,
        qty: null,
        mdh: "0.3mm↑",
        break_away_rail: 'N/A',
        break_away_rail_num: null,
        pcb_thickness: "1.6",
        pcb_solder_mask_color: 'Green',
        silkscreen: 'White',
        electrical_test: 'Sample Test Free',
        finished_copper_weight: '1oz',
        pcb_inner_copper_weigh: '0.5oz',
        min_trace_space_outer: '6/6mil↑',
        min_drilled_hole: '',
        via_process: 'Tenting Vias',
        surface_finish: 'HASL',
        thickness_of_immersion_gold: '1μ″',
        special_process: [],
        special_process_arr: ['Impedance'],
        hdi_structure: 'Rank 1',
        stack_up: 'No Requirement',
        x_out: 'Accepts',
        personalized_service: [],
        personalized_service_arr: [],
        report_format: 'Paper',
        ul_mark: 'UL+Week/Year',
        add_po_no: '',
        special_requests: '',
        original_gerber_url: '',
        original_gerber_name: '',
        original_bom_url: '',
        original_bom_name: '',
        original_coordinate_url: '',
        original_coordinate_name: '',

      },
        this.onRemoveGerber2();
      this.changePcbSoldermaskColor2('Green');
      this.changeLayerCount2('2')
    },
    refreshFun3() {
      this.form3 = {
        border_type: 'Framework',
        stencil_type: 'Stencil for Solder Paste',
        printing_method: 'Manual Printing',
        size: '300x400mm(Valid area 140x240mm)',
        stencil_side: 'Top',
        quantity: '1',
        thickness: '0.10mm',
        existing_fiducials: 'None',
        electropolishing: 'Grinding and Polishing',
        engineering_requirements: 'welllink specification',
        stencil_add_po_no: '',
        stencil_special_requests: '',
        name: '',
        company: '',
        email: '',
      }
      this.borderTypeChange('Framework');
      this.stencilSideChange('Top')
    },
    handleInput(event) {
    },
    checkboxchange(value) {
    },
    handleCheckboxChange(value) {
      // 处理多选框的变化
    },
    closePopover(index) {
      if (index == 1) {
        this.$refs.popover.doClose();
        this.$refs['form'].clearValidate();
      } else {
        this.$refs.popover2.doClose();
        this.$refs['form2'].clearValidate();
      }
    },
    numberChange(value, index) {
      this.form.qty = value
      this.form.pcba_qty = value
      this.activeTag = index
    },
    numberChange2(value, index) {
      this.form2.qty = value
      this.activeTag = index
    },
    onSubmit() {
      const params = { ...this.form }
      params.special_process = params.special_process.toString();
      params.personalized_service = params.personalized_service.toString();
      params.layer_count = parseInt(params.layer_count);
      params.min_drilled_hole = params.mdh
      var formData = new FormData()
      formData.append('o', JSON.stringify(params))
      if (Number(params.size_one) <= 0 || Number(params.size_two) <= 0) {
        this.$message.error('Size (single) cannot be empty!');
        return false;
      }
      if (params.qty == null || (params.qty) < 0) {
        this.$message.error('Qty(single) cannot be empty!');
        return false;
      }
      console.log('params1:',params)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          inquiry_pcba_save(formData).then(res => {
            if (res.success) {
              this.$message({
                message: 'success',
                type: 'success'
              });
              window.location.href="https://www.welllinkchips.com/submit_pcb";
            } else {
              this.errorMessage = '<div style="padding:10px">' + res.msg + '</div>';
              this.$alert(this.errorMessage, '错误', {
                dangerouslyUseHTMLString: true
              });
            }
          }).catch(error => {
            console.log(error)
          })
        }

      })


    },
    onSubmit2() {
      const params = { ...this.form2, ...this.form3 }
      params.special_process = params.special_process.toString();
      params.personalized_service = params.personalized_service.toString();
      params.layer_count = parseInt(params.layer_count);
      params.min_drilled_hole = params.mdh
      const form1 = { ...this.form }
      params.inquiry_pcba_type = form1.inquiry_pcba_type
      var formData = new FormData()
      formData.append('o', JSON.stringify(params))
      if (Number(params.size_one) <= 0 || Number(params.size_two) <= 0) {
        this.$message.error('Size (single) cannot be empty!');
        return false;
      }
      if (params.qty == null || (params.qty) < 0) {
        this.$message.error('Qty(single) cannot be empty!');
        return false;
      }
      console.log('params2:',params)
      this.$refs['form3'].validate((valid) => {
        if (valid) {
          inquiry_pcba_save(formData).then(res => {
            if (res.success) {
              this.$message({
                message: 'success',
                type: 'success'
              });
              window.location.href="https://www.welllinkchips.com/submit_pcb";
            } else {
              this.errorMessage = '<div style="padding:10px">' + res.msg + '</div>';
              this.$alert(this.errorMessage, '错误', {
                dangerouslyUseHTMLString: true
              });
            }
          }).catch(error => {
            console.log(error)
          })
        }

      })

    },
    beforeUploadBOM(file) {
      const extension = file.name.split('.').pop().toLowerCase();
      // BOM 文件只能上传zip/rar,文件大小不超过50MB
      const bomAllowedTypes = ['xls', 'xlsx', 'csv'];
      const bomSize = file.size / 1024 / 1024 < 5;
      if (!bomAllowedTypes.includes(extension)) {
        this.$message.error('Only XLS or XLSX or CSV files, Up to 5MB');
        return false;
      }
      if (!bomSize) {
        this.$message.error('Only XLS or XLSX or CSV files, Up to 5MB');
        return false;
      }
      return true
    },
    beforeUploadGerber(file) {
      const extension = file.name.split('.').pop().toLowerCase();
      // Gerber 文件只能上传zip/rar,文件大小不超过50MB
      const gerberAllowedTypes = ['zip', 'rar'];
      const gerberSize = file.size / 1024 / 1024 < 50;
      if (!gerberAllowedTypes.includes(extension)) {
        this.$message.error('Only ZIP or RAR files, Up to 50MB');
        return false;
      }
      if (!gerberSize) {
        this.$message.error('Only ZIP or RAR files, Up to 50MB');
        return false;
      }
      return true
    },

    onRemoveGerber2() {
      this.fileListGerber2 = []
      this.uploadProgressGerber2 = 0;
      this.isUploadDisabledGerber2 = false;
      this.form2.original_gerber_url = '';
      this.form2.original_gerber_name = '';
    },

    onRemoveGerber() {
      this.fileListGerber = []
      this.uploadProgressGerber = 0;
      this.isUploadDisabledGerber = false;
      this.form.original_gerber_url = '';
      this.form.original_gerber_name = '';
    },
    onRemoveBom() {
      this.fileListBom = []
      this.uploadProgressBom = 0;
      this.isUploadDisabledBOM = false
      this.form.original_bom_url = '';
      this.form.original_bom_name = '';
    },
    onRemoveCoordinate() {
      this.fileListCoordinate = []
      this.uploadProgressCoordinate = 0;
      this.isUploadDisabledCoordinate = false;
      this.form.original_coordinate_url = '';
      this.form.original_coordinate_name = '';
    },
    httpRequestGerber2(item) {
      var formData = new FormData()
      formData.append('file', item.file)
      upload(formData).then(res => {
        if (res.success) {
          this.fileNameGerber2 = item.file.name
          this.uploadProgressGerber2 = 100;
          this.isUploadDisabledGerber2 = true;
          this.form2.original_gerber_url = res.data.url
          this.form2.original_gerber_name = res.data.filename
        }
      }).catch(error => {
        console.log('error', error)
      })
    },
    httpRequestGerber(item) {
      var formData = new FormData()
      formData.append('file', item.file)
      upload(formData).then(res => {
        if (res.success) {
          this.fileNameGerber = item.file.name
          this.uploadProgressGerber = 100;
          this.isUploadDisabledGerber = true;
          this.form.original_gerber_url = res.data.url
          this.form.original_gerber_name = res.data.filename
        }
      }).catch(error => {
        console.log('error', error)
      })
    },
    httpRequestBom(item) {
      var formData = new FormData()
      formData.append('file', item.file)
      upload(formData).then(res => {
        if (res.success) {
          this.fileNameBom = item.file.name
          this.uploadProgressBom = 100;
          this.isUploadDisabledBOM = true;
          this.form.original_bom_url = res.data.url
          this.form.original_bom_name = res.data.filename
        }
      }).catch(error => {
        console.log('error', error)
      })
    },
    httpRequestCoordinate(item) {
      var formData = new FormData()
      formData.append('file', item.file)
      upload(formData).then(res => {
        if (res.success) {
          this.fileNameCoordinate = item.file.name
          this.uploadProgressCoordinate = 100;
          this.isUploadDisabledCoordinate = true;
          this.form.original_coordinate_url = res.data.url
          this.form.original_coordinate_name = res.data.filename
        }
      }).catch(error => {
        console.log('error', error)
      })
    },

    changeLayerCount(e) {
      if (['16', '18', '20'].includes(this.form.layer_count)) {
        this.form.pcb_thickness = '2.0'
      } else {
        this.form.pcb_thickness = '1.6'
      }

      if (['1', '2'].includes(this.form.layer_count)) {
        this.pcb_inner_copper_weigh_show = false;
      } else {
        this.pcb_inner_copper_weigh_show = true;
      }
      // TG
      if (this.form.layer_count === '1' || this.form.layer_count === '2') {
        this.showTG = false;
      } else {
        this.showTG = true;
      }

      this.dataMap.TGList = this.dataMap.TGList.map((item) => {
        if (this.form.layer_count === '4' && item.key === 'TG170') {
          return {
            key: item.key,
            disabled: true
          }
        }
        if ((this.form.layer_count === '6' || this.form.layer_count === '8') && item.key === 'TG130') {
          this.form.tg = 'TG150';
          return {
            key: item.key,
            disabled: true
          }
        }

        if (['10', '12', '14', '16', '18', '20'].includes(this.form.layer_count) && (item.key === 'TG130' || item.key === 'TG150')) {
          this.form.tg = 'TG170';
          return {
            key: item.key,
            disabled: true
          }
        }

        item.disabled = false;
        return item;
      })
      // min_trace_space_outer
      this.dataMap.min_trace_space_outer_list = this.dataMap.min_trace_space_outer_list.map((item) => {
        if (this.form.layer_count == '1' || this.form.layer_count == '4') {
          this.form.min_trace_space_outer = "6/6mil↑"
        }
        if (this.form.layer_count === '1' && (item.key === 'min_trace_space_outer_list4' || item.key === 'min_trace_space_outer_list3_5')) {

          return {
            key: item.key,
            value: item.value,
            disabled: true
          }
        }
        if (this.form.layer_count === '2' && item.key === 'min_trace_space_outer_list3_5') {
          return {
            key: item.key,
            value: item.value,
            disabled: true
          }
        }

        item.disabled = false;
        return item;
      })

      // special_process
      this.dataMap.special_process_list = this.dataMap.special_process_list.map((item) => {

        if (Number(this.form.layer_count) < 4 && item.key === 'hdi') {
          return {
            key: item.key,
            label: item.label,
            value: item.value,
            disabled: true
          }
        }

        item.disabled = false;
        return item;
      })

      if (this.form.layer_count != '1') {
        this.form.electrical_test = "Sample Test Free"
        this.dataMap.electrical_test_list = [
          {
            key: "Sample_Test_Free",
            label: "Sample Test Free",
            value: "Sample Test Free",
          }
        ]
      } else {
        this.form.electrical_test = "FQC Visual Inspections Free"
        this.dataMap.electrical_test_list = [
          {
            key: "FQC_Visual_Inspections_Free",
            label: "FQC Visual Inspections Free",
            value: "FQC Visual Inspections Free",
          }
        ]
      }

    },
    changeLayerCount2(e) {
      if (['16', '18', '20'].includes(this.form2.layer_count)) {
        this.form2.pcb_thickness = '2.0'
      } else {
        this.form2.pcb_thickness = '1.6'
      }

      if (['1', '2'].includes(this.form.layer_count)) {
        this.pcb_inner_copper_weigh_show2 = false;
      } else {
        this.pcb_inner_copper_weigh_show2 = true;
      }
      // TG
      if (this.form2.layer_count === '1' || this.form2.layer_count === '2') {
        this.showTG2 = false;
      } else {
        this.showTG2 = true;
      }

      this.dataMap.TGList = this.dataMap.TGList.map((item) => {
        if (this.form2.layer_count === '4' && item.key === 'TG170') {
          return {
            key: item.key,
            disabled: true
          }
        }
        if ((this.form2.layer_count === '6' || this.form2.layer_count === '8') && item.key === 'TG130') {
          this.form2.tg = 'TG150';
          return {
            key: item.key,
            disabled: true
          }
        }

        if (['10', '12', '14', '16', '18', '20'].includes(this.form2.layer_count) && (item.key === 'TG130' || item.key === 'TG150')) {
          this.form2.tg = 'TG170';
          return {
            key: item.key,
            disabled: true
          }
        }

        item.disabled = false;
        return item;
      })
      // min_trace_space_outer
      this.dataMap.min_trace_space_outer_list = this.dataMap.min_trace_space_outer_list.map((item) => {
        if (this.form2.layer_count == '1' || this.form2.layer_count == '4') {
          this.form2.min_trace_space_outer = "6/6mil↑"
        }
        if (this.form2.layer_count === '1' && (item.key === 'min_trace_space_outer_list4' || item.key === 'min_trace_space_outer_list3_5')) {

          return {
            key: item.key,
            value: item.value,
            disabled: true
          }
        }
        if (this.form2.layer_count === '2' && item.key === 'min_trace_space_outer_list3_5') {
          return {
            key: item.key,
            value: item.value,
            disabled: true
          }
        }

        item.disabled = false;
        return item;
      })

      // special_process
      this.dataMap.special_process_list = this.dataMap.special_process_list.map((item) => {

        if (Number(this.form2.layer_count) < 4 && item.key === 'hdi') {
          return {
            key: item.key,
            label: item.label,
            value: item.value,
            disabled: true
          }
        }

        item.disabled = false;
        return item;
      })

      if (this.form2.layer_count != '1') {
        this.form2.electrical_test = "Sample Test Free"
        this.dataMap.electrical_test_list2 = [
          {
            key: "Sample_Test_Free",
            label: "Sample Test Free",
            value: "Sample Test Free",
          }
        ]
      } else {
        this.form2.electrical_test = "FQC Visual Inspections Free"
        this.dataMap.electrical_test_list2 = [
          {
            key: "FQC_Visual_Inspections_Free",
            label: "FQC Visual Inspections Free",
            value: "FQC Visual Inspections Free",
          }
        ]
      }

    },

    changePcbSoldermaskColor2(e) {
      if (e === 'White') {
        this.dataMap.silkscreen_list2 = [
          {
            key: "white",
            label: "White",
            value: "White",
            disabled: true
          },
          {
            key: "black",
            label: "Black",
            value: "Black",
            disabled: false
          }
        ]
        this.form2.silkscreen = 'Black'
      } else {
        this.dataMap.silkscreen_list2 = [
          {
            key: "white",
            label: "White",
            value: "White",
            disabled: false
          },
          {
            key: "black",
            label: "Black",
            value: "Black",
            disabled: true
          }
        ]
        this.form2.silkscreen = 'White'
      }

    },
    changePcbSoldermaskColor(e) {
      if (e === 'White') {
        this.dataMap.silkscreen_list = [
          {
            key: "white",
            label: "White",
            value: "White",
            disabled: true
          },
          {
            key: "black",
            label: "Black",
            value: "Black",
            disabled: false
          }
        ]
        this.form.silkscreen = 'Black'
      } else {
        this.dataMap.silkscreen_list = [
          {
            key: "white",
            label: "White",
            value: "White",
            disabled: false
          },
          {
            key: "black",
            label: "Black",
            value: "Black",
            disabled: true
          }
        ]
        this.form.silkscreen = 'White'
      }

    },
    borderTypeChange(e) {
      // Printing Method
      this.dataMap.printing_method_list = this.dataMap.printing_method_list.map((item) => {
        if ((this.form3.border_type === 'Framework' || this.form3.border_type === 'Non-framework') && (item.key === 'semiautomaticprinting' || item.key === 'fullyautomaticprinting')) {
          this.form3.printing_method = 'Manual Printing';
          return {
            key: item.key,
            label: item.label,
            value: item.value,
            disabled: true
          }
        }
        item.disabled = false;
        return item;
      })
      // Stencil Type
      this.dataMap.stencil_type_list = this.dataMap.stencil_type_list.map((item) => {
        if (this.form3.border_type === 'Non-framework' && item.key === 'step_down_stencil') {
          this.form3.stencil_type = 'Stencil for Solder Paste';
          return {
            key: item.key,
            label: item.label,
            value: item.value,
            tips: `<img src="${require('../src/assets/images/img_01.png')}" alt="" />`,
            disabled: true
          }
        }
        item.disabled = false;
        return item;
      })

      // size_list
      if (e === 'Framework') {
        this.form3.size = '300x400mm(Valid area 140x240mm)'
        this.dataMap.size_list = this.dataMap.size_list1
      } else {
        this.form3.size = '280x380mm(Valid area 190x290mm)'
        this.dataMap.size_list = this.dataMap.size_list2
      }

    },
    stencilSideChange(e) {
      if (this.form3.stencil_side == `Top & Bottom ( Different Solder Paste )`) {
        this.form3.quantity = 2
      } else {
        this.form3.quantity = 1
      }
    }
  }
};
</script>

<style scoped>
/* 已上传文件的按钮样式 */
.is-uploaded {
  opacity: 0.5;
  /* 设置按钮透明度为50% */
  cursor: not-allowed;
  /* 设置鼠标指针为不可点击 */
}
</style>
